
      'use strict';

      const translations = {
        en: {
          name: 'English',
          button: 'Withdraw Contract',
          title: 'Request order withdrawal',
          intro: 'Enter your order details to verify the purchase and select the items you want to withdraw.',
          fullName: 'Full name',
          email: 'Email address',
          order: 'Order ID',
          note: 'Additional note',
          verify: 'Verify order',
          found: 'Order verified successfully',
          choose: 'Select items for withdrawal',
          submit: 'Submit withdrawal request',
          notFound: 'We could not find this order. Check the order ID and try again.',
          mismatch: 'The email address does not match this order.',
          required: 'Please complete all required fields.',
          pick: 'Select at least one item.',
          success: 'Withdrawal request submitted',
          successBody: 'Your request has been recorded and a confirmation email has been sent.',
          close: 'Close',
          total: 'Order total',
        },
        de: {
          name: 'Deutsch',
          button: 'Vertrag widerrufen',
          title: 'Widerruf der Bestellung beantragen',
          intro: 'Geben Sie Ihre Bestelldaten ein, um den Kauf zu prüfen und Artikel auszuwählen.',
          fullName: 'Vollständiger Name',
          email: 'E-Mail-Adresse',
          order: 'Bestellnummer',
          note: 'Zusätzliche Anmerkung',
          verify: 'Bestellung prüfen',
          found: 'Bestellung erfolgreich bestätigt',
          choose: 'Artikel für den Widerruf auswählen',
          submit: 'Widerruf absenden',
          notFound: 'Diese Bestellung wurde nicht gefunden. Prüfen Sie die Bestellnummer.',
          mismatch: 'Die E-Mail-Adresse stimmt nicht mit der Bestellung überein.',
          required: 'Bitte füllen Sie alle Pflichtfelder aus.',
          pick: 'Wählen Sie mindestens einen Artikel aus.',
          success: 'Widerruf eingereicht',
          successBody: 'Ihr Antrag wurde gespeichert und eine Bestätigung wurde versendet.',
          close: 'Schließen',
          total: 'Bestellsumme',
        },
        nl: {
          name: 'Nederlands',
          button: 'Contract intrekken',
          title: 'Herroeping aanvragen',
          intro: 'Voer uw bestelgegevens in en selecteer de artikelen die u wilt herroepen.',
          fullName: 'Volledige naam',
          email: 'E-mailadres',
          order: 'Bestelnummer',
          note: 'Aanvullende opmerking',
          verify: 'Bestelling controleren',
          found: 'Bestelling succesvol geverifieerd',
          choose: 'Selecteer artikelen',
          submit: 'Herroepingsverzoek indienen',
          notFound: 'Deze bestelling is niet gevonden. Controleer het bestelnummer.',
          mismatch: 'Het e-mailadres hoort niet bij deze bestelling.',
          required: 'Vul alle verplichte velden in.',
          pick: 'Selecteer minimaal één artikel.',
          success: 'Verzoek ingediend',
          successBody: 'Uw verzoek is opgeslagen en een bevestiging is verzonden.',
          close: 'Sluiten',
          total: 'Besteltotaal',
        },
        fr: {
          name: 'Français',
          button: 'Retirer le contrat',
          title: 'Demander la rétractation',
          intro: 'Saisissez les informations de commande puis sélectionnez les articles concernés.',
          fullName: 'Nom complet',
          email: 'Adresse e-mail',
          order: 'Numéro de commande',
          note: 'Note supplémentaire',
          verify: 'Vérifier la commande',
          found: 'Commande vérifiée avec succès',
          choose: 'Sélectionnez les articles',
          submit: 'Envoyer la demande',
          notFound: 'Commande introuvable. Vérifiez le numéro de commande.',
          mismatch: 'L’adresse e-mail ne correspond pas à cette commande.',
          required: 'Veuillez remplir tous les champs obligatoires.',
          pick: 'Sélectionnez au moins un article.',
          success: 'Demande envoyée',
          successBody: 'Votre demande a été enregistrée et un e-mail de confirmation a été envoyé.',
          close: 'Fermer',
          total: 'Total de la commande',
        },
        el: {
          name: 'Ελληνικά',
          button: 'Ανάκληση Συμβολαίου',
          title: 'Αίτημα υπαναχώρησης',
          intro: 'Εισαγάγετε τα στοιχεία παραγγελίας και επιλέξτε τα προϊόντα.',
          fullName: 'Ονοματεπώνυμο',
          email: 'Διεύθυνση email',
          order: 'Αριθμός παραγγελίας',
          note: 'Πρόσθετη σημείωση',
          verify: 'Επαλήθευση παραγγελίας',
          found: 'Η παραγγελία επαληθεύτηκε',
          choose: 'Επιλέξτε προϊόντα',
          submit: 'Υποβολή αιτήματος',
          notFound: 'Η παραγγελία δεν βρέθηκε.',
          mismatch: 'Το email δεν αντιστοιχεί στην παραγγελία.',
          required: 'Συμπληρώστε όλα τα απαιτούμενα πεδία.',
          pick: 'Επιλέξτε τουλάχιστον ένα προϊόν.',
          success: 'Το αίτημα υποβλήθηκε',
          successBody: 'Το αίτημα καταγράφηκε και στάλθηκε email επιβεβαίωσης.',
          close: 'Κλείσιμο',
          total: 'Σύνολο',
        },
        fi: {
          name: 'Suomi',
          button: 'Peruuta sopimus',
          title: 'Tee peruuttamispyyntö',
          intro: 'Anna tilaustiedot ja valitse peruutettavat tuotteet.',
          fullName: 'Koko nimi',
          email: 'Sähköpostiosoite',
          order: 'Tilausnumero',
          note: 'Lisätiedot',
          verify: 'Tarkista tilaus',
          found: 'Tilaus vahvistettu',
          choose: 'Valitse tuotteet',
          submit: 'Lähetä pyyntö',
          notFound: 'Tilausta ei löytynyt.',
          mismatch: 'Sähköposti ei vastaa tilausta.',
          required: 'Täytä kaikki pakolliset kentät.',
          pick: 'Valitse vähintään yksi tuote.',
          success: 'Pyyntö lähetetty',
          successBody: 'Pyyntö tallennettiin ja vahvistus lähetettiin.',
          close: 'Sulje',
          total: 'Tilauksen summa',
        },
        sv: {
          name: 'Svenska',
          button: 'Återkalla kontrakt',
          title: 'Begär orderånger',
          intro: 'Ange orderuppgifter och välj de artiklar du vill ångra.',
          fullName: 'Fullständigt namn',
          email: 'E-postadress',
          order: 'Ordernummer',
          note: 'Ytterligare kommentar',
          verify: 'Verifiera order',
          found: 'Ordern har verifierats',
          choose: 'Välj artiklar',
          submit: 'Skicka begäran',
          notFound: 'Ordern kunde inte hittas.',
          mismatch: 'E-postadressen matchar inte ordern.',
          required: 'Fyll i alla obligatoriska fält.',
          pick: 'Välj minst en artikel.',
          success: 'Begäran skickad',
          successBody: 'Begäran registrerades och en bekräftelse skickades.',
          close: 'Stäng',
          total: 'Ordersumma',
        },
        hu: {
          name: 'Magyar',
          button: 'Szerződés visszavonása',
          title: 'Elállási kérelem',
          intro: 'Adja meg a rendelési adatokat és válassza ki a termékeket.',
          fullName: 'Teljes név',
          email: 'E-mail-cím',
          order: 'Rendelési azonosító',
          note: 'További megjegyzés',
          verify: 'Rendelés ellenőrzése',
          found: 'A rendelés ellenőrzése sikeres',
          choose: 'Válasszon termékeket',
          submit: 'Kérelem elküldése',
          notFound: 'A rendelés nem található.',
          mismatch: 'Az e-mail-cím nem egyezik a rendeléssel.',
          required: 'Töltse ki a kötelező mezőket.',
          pick: 'Válasszon legalább egy terméket.',
          success: 'Kérelem elküldve',
          successBody: 'A kérelmet rögzítettük és visszaigazolást küldtünk.',
          close: 'Bezárás',
          total: 'Rendelés összege',
        },
        ga: {
          name: 'Gaeilge',
          button: 'Tarraingt Siar an Conradh',
          title: 'Iarratas tarraingthe siar',
          intro: 'Cuir sonraí an ordaithe isteach agus roghnaigh na míreanna.',
          fullName: 'Ainm iomlán',
          email: 'Seoladh ríomhphoist',
          order: 'Aitheantas ordaithe',
          note: 'Nóta breise',
          verify: 'Fíoraigh an t-ordú',
          found: 'Ordú fíoraithe',
          choose: 'Roghnaigh míreanna',
          submit: 'Cuir an t-iarratas isteach',
          notFound: 'Níor aimsíodh an t-ordú.',
          mismatch: 'Ní mheaitseálann an ríomhphost an t-ordú.',
          required: 'Comhlánaigh na réimsí riachtanacha.',
          pick: 'Roghnaigh mír amháin ar a laghad.',
          success: 'Iarratas seolta',
          successBody: 'Taifeadadh an t-iarratas agus seoladh deimhniú.',
          close: 'Dún',
          total: 'Iomlán',
        },
        it: {
          name: 'Italiano',
          button: 'Ritirare il contratto',
          title: 'Richiedi il recesso',
          intro: 'Inserisci i dati dell’ordine e seleziona gli articoli.',
          fullName: 'Nome completo',
          email: 'Indirizzo email',
          order: 'ID ordine',
          note: 'Nota aggiuntiva',
          verify: 'Verifica ordine',
          found: 'Ordine verificato',
          choose: 'Seleziona gli articoli',
          submit: 'Invia richiesta',
          notFound: 'Ordine non trovato.',
          mismatch: 'L’email non corrisponde all’ordine.',
          required: 'Compila tutti i campi obbligatori.',
          pick: 'Seleziona almeno un articolo.',
          success: 'Richiesta inviata',
          successBody: 'La richiesta è stata registrata e la conferma è stata inviata.',
          close: 'Chiudi',
          total: 'Totale ordine',
        },
        pl: {
          name: 'Polski',
          button: 'Wycofaj umowę',
          title: 'Wniosek o odstąpienie',
          intro: 'Wprowadź dane zamówienia i wybierz produkty.',
          fullName: 'Imię i nazwisko',
          email: 'Adres e-mail',
          order: 'Numer zamówienia',
          note: 'Dodatkowa uwaga',
          verify: 'Sprawdź zamówienie',
          found: 'Zamówienie zweryfikowane',
          choose: 'Wybierz produkty',
          submit: 'Wyślij wniosek',
          notFound: 'Nie znaleziono zamówienia.',
          mismatch: 'Adres e-mail nie pasuje do zamówienia.',
          required: 'Uzupełnij wymagane pola.',
          pick: 'Wybierz co najmniej jeden produkt.',
          success: 'Wniosek wysłany',
          successBody: 'Wniosek zapisano i wysłano potwierdzenie.',
          close: 'Zamknij',
          total: 'Suma zamówienia',
        },
        ro: {
          name: 'Română',
          button: 'Retragere contract',
          title: 'Cerere de retragere',
          intro: 'Introduceți datele comenzii și selectați produsele.',
          fullName: 'Nume complet',
          email: 'Adresă de e-mail',
          order: 'ID comandă',
          note: 'Notă suplimentară',
          verify: 'Verifică comanda',
          found: 'Comandă verificată',
          choose: 'Selectați produsele',
          submit: 'Trimite cererea',
          notFound: 'Comanda nu a fost găsită.',
          mismatch: 'Adresa de e-mail nu corespunde comenzii.',
          required: 'Completați câmpurile obligatorii.',
          pick: 'Selectați cel puțin un produs.',
          success: 'Cerere trimisă',
          successBody: 'Cererea a fost înregistrată și confirmarea a fost trimisă.',
          close: 'Închide',
          total: 'Total comandă',
        },
        pt: {
          name: 'Português (Portugal)',
          button: 'Retirar contrato',
          title: 'Pedido de livre resolução',
          intro: 'Introduza os dados da encomenda e selecione os artigos.',
          fullName: 'Nome completo',
          email: 'Endereço de e-mail',
          order: 'ID da encomenda',
          note: 'Nota adicional',
          verify: 'Verificar encomenda',
          found: 'Encomenda verificada',
          choose: 'Selecione os artigos',
          submit: 'Enviar pedido',
          notFound: 'A encomenda não foi encontrada.',
          mismatch: 'O e-mail não corresponde à encomenda.',
          required: 'Preencha os campos obrigatórios.',
          pick: 'Selecione pelo menos um artigo.',
          success: 'Pedido enviado',
          successBody: 'O pedido foi registado e a confirmação foi enviada.',
          close: 'Fechar',
          total: 'Total da encomenda',
        },
        es: {
          name: 'Español',
          button: 'Retirar contrato',
          title: 'Solicitud de desistimiento',
          intro: 'Introduce los datos del pedido y selecciona los artículos.',
          fullName: 'Nombre completo',
          email: 'Correo electrónico',
          order: 'ID del pedido',
          note: 'Nota adicional',
          verify: 'Verificar pedido',
          found: 'Pedido verificado',
          choose: 'Selecciona los artículos',
          submit: 'Enviar solicitud',
          notFound: 'No se encontró el pedido.',
          mismatch: 'El correo no coincide con el pedido.',
          required: 'Completa los campos obligatorios.',
          pick: 'Selecciona al menos un artículo.',
          success: 'Solicitud enviada',
          successBody: 'La solicitud se registró y se envió la confirmación.',
          close: 'Cerrar',
          total: 'Total del pedido',
        },
        cs: {
          name: 'Čeština',
          button: 'Odstoupit od smlouvy',
          title: 'Žádost o odstoupení',
          intro: 'Zadejte údaje objednávky a vyberte položky.',
          fullName: 'Celé jméno',
          email: 'E-mailová adresa',
          order: 'Číslo objednávky',
          note: 'Doplňující poznámka',
          verify: 'Ověřit objednávku',
          found: 'Objednávka ověřena',
          choose: 'Vyberte položky',
          submit: 'Odeslat žádost',
          notFound: 'Objednávka nebyla nalezena.',
          mismatch: 'E-mail neodpovídá objednávce.',
          required: 'Vyplňte povinná pole.',
          pick: 'Vyberte alespoň jednu položku.',
          success: 'Žádost odeslána',
          successBody: 'Žádost byla zaznamenána a potvrzení odesláno.',
          close: 'Zavřít',
          total: 'Celkem',
        },
        da: {
          name: 'Dansk',
          button: 'Træk kontrakt tilbage',
          title: 'Fortrydelsesanmodning',
          intro: 'Indtast ordreoplysninger og vælg varerne.',
          fullName: 'Fulde navn',
          email: 'E-mailadresse',
          order: 'Ordrenummer',
          note: 'Yderligere note',
          verify: 'Bekræft ordre',
          found: 'Ordren er bekræftet',
          choose: 'Vælg varer',
          submit: 'Indsend anmodning',
          notFound: 'Ordren blev ikke fundet.',
          mismatch: 'E-mailadressen matcher ikke ordren.',
          required: 'Udfyld de obligatoriske felter.',
          pick: 'Vælg mindst én vare.',
          success: 'Anmodning sendt',
          successBody: 'Anmodningen blev registreret, og en bekræftelse blev sendt.',
          close: 'Luk',
          total: 'Ordretotal',
        },
        et: {
          name: 'Eesti',
          button: 'Lepingust taganemine',
          title: 'Taganemistaotlus',
          intro: 'Sisestage tellimuse andmed ja valige tooted.',
          fullName: 'Täisnimi',
          email: 'E-posti aadress',
          order: 'Tellimuse ID',
          note: 'Lisamärkus',
          verify: 'Kontrolli tellimust',
          found: 'Tellimus kinnitatud',
          choose: 'Valige tooted',
          submit: 'Esita taotlus',
          notFound: 'Tellimust ei leitud.',
          mismatch: 'E-post ei vasta tellimusele.',
          required: 'Täitke kohustuslikud väljad.',
          pick: 'Valige vähemalt üks toode.',
          success: 'Taotlus saadetud',
          successBody: 'Taotlus salvestati ja kinnitus saadeti.',
          close: 'Sulge',
          total: 'Tellimuse summa',
        },
        lv: {
          name: 'Latviešu',
          button: 'Atsaukt līgumu',
          title: 'Atteikuma pieprasījums',
          intro: 'Ievadiet pasūtījuma datus un atlasiet preces.',
          fullName: 'Pilns vārds',
          email: 'E-pasta adrese',
          order: 'Pasūtījuma ID',
          note: 'Papildu piezīme',
          verify: 'Pārbaudīt pasūtījumu',
          found: 'Pasūtījums pārbaudīts',
          choose: 'Atlasiet preces',
          submit: 'Iesniegt pieprasījumu',
          notFound: 'Pasūtījums nav atrasts.',
          mismatch: 'E-pasts neatbilst pasūtījumam.',
          required: 'Aizpildiet obligātos laukus.',
          pick: 'Atlasiet vismaz vienu preci.',
          success: 'Pieprasījums nosūtīts',
          successBody: 'Pieprasījums reģistrēts un apstiprinājums nosūtīts.',
          close: 'Aizvērt',
          total: 'Pasūtījuma summa',
        },
        lt: {
          name: 'Lietuvių',
          button: 'Atšaukti sutartį',
          title: 'Atsisakymo prašymas',
          intro: 'Įveskite užsakymo duomenis ir pasirinkite prekes.',
          fullName: 'Vardas ir pavardė',
          email: 'El. pašto adresas',
          order: 'Užsakymo ID',
          note: 'Papildoma pastaba',
          verify: 'Patikrinti užsakymą',
          found: 'Užsakymas patikrintas',
          choose: 'Pasirinkite prekes',
          submit: 'Pateikti prašymą',
          notFound: 'Užsakymas nerastas.',
          mismatch: 'El. paštas neatitinka užsakymo.',
          required: 'Užpildykite privalomus laukus.',
          pick: 'Pasirinkite bent vieną prekę.',
          success: 'Prašymas išsiųstas',
          successBody: 'Prašymas užregistruotas ir patvirtinimas išsiųstas.',
          close: 'Uždaryti',
          total: 'Užsakymo suma',
        },
        mt: {
          name: 'Malti',
          button: 'Irtirar tal-Kuntratt',
          title: 'Talba ta’ rtirar',
          intro: 'Daħħal id-dettalji tal-ordni u agħżel l-oġġetti.',
          fullName: 'Isem sħiħ',
          email: 'Indirizz elettroniku',
          order: 'ID tal-ordni',
          note: 'Nota addizzjonali',
          verify: 'Ivverifika l-ordni',
          found: 'Ordni vverifikata',
          choose: 'Agħżel l-oġġetti',
          submit: 'Ibgħat it-talba',
          notFound: 'L-ordni ma nstabitx.',
          mismatch: 'L-email ma taqbilx mal-ordni.',
          required: 'Imla l-oqsma meħtieġa.',
          pick: 'Agħżel mill-inqas oġġett wieħed.',
          success: 'Talba mibgħuta',
          successBody: 'It-talba ġiet irreġistrata u ntbagħtet konferma.',
          close: 'Agħlaq',
          total: 'Total tal-ordni',
        },
        sk: {
          name: 'Slovenčina',
          button: 'Odstúpiť od zmluvy',
          title: 'Žiadosť o odstúpenie',
          intro: 'Zadajte údaje objednávky a vyberte položky.',
          fullName: 'Celé meno',
          email: 'E-mailová adresa',
          order: 'Číslo objednávky',
          note: 'Doplňujúca poznámka',
          verify: 'Overiť objednávku',
          found: 'Objednávka overená',
          choose: 'Vyberte položky',
          submit: 'Odoslať žiadosť',
          notFound: 'Objednávka sa nenašla.',
          mismatch: 'E-mail nezodpovedá objednávke.',
          required: 'Vyplňte povinné polia.',
          pick: 'Vyberte aspoň jednu položku.',
          success: 'Žiadosť odoslaná',
          successBody: 'Žiadosť bola zaznamenaná a potvrdenie odoslané.',
          close: 'Zavrieť',
          total: 'Suma objednávky',
        },
        sl: {
          name: 'Slovenščina',
          button: 'Odstop od pogodbe',
          title: 'Zahteva za odstop',
          intro: 'Vnesite podatke naročila in izberite izdelke.',
          fullName: 'Polno ime',
          email: 'E-poštni naslov',
          order: 'ID naročila',
          note: 'Dodatna opomba',
          verify: 'Preveri naročilo',
          found: 'Naročilo preverjeno',
          choose: 'Izberite izdelke',
          submit: 'Pošlji zahtevo',
          notFound: 'Naročila ni bilo mogoče najti.',
          mismatch: 'E-pošta se ne ujema z naročilom.',
          required: 'Izpolnite obvezna polja.',
          pick: 'Izberite vsaj en izdelek.',
          success: 'Zahteva poslana',
          successBody: 'Zahteva je bila zabeležena in potrdilo poslano.',
          close: 'Zapri',
          total: 'Skupaj naročilo',
        },
        hr: {
          name: 'Hrvatski',
          button: 'Povlačenje ugovora',
          title: 'Zahtjev za odustajanje',
          intro: 'Unesite podatke narudžbe i odaberite artikle.',
          fullName: 'Puno ime',
          email: 'Adresa e-pošte',
          order: 'ID narudžbe',
          note: 'Dodatna napomena',
          verify: 'Provjeri narudžbu',
          found: 'Narudžba potvrđena',
          choose: 'Odaberite artikle',
          submit: 'Pošalji zahtjev',
          notFound: 'Narudžba nije pronađena.',
          mismatch: 'E-pošta ne odgovara narudžbi.',
          required: 'Ispunite obavezna polja.',
          pick: 'Odaberite barem jedan artikl.',
          success: 'Zahtjev poslan',
          successBody: 'Zahtjev je evidentiran i potvrda je poslana.',
          close: 'Zatvori',
          total: 'Ukupno narudžbe',
        },
      };

      const UI_KEYS = [
        'interactiveDemo',
        'openDemo',
        'frontendBackend',
        'heroOne',
        'heroTwo',
        'heroDescription',
        'validDemo',
        'orderLabel',
        'emailLabel',
        'storefront',
        'requestsBackend',
        'appSettings',
        'popupForm',
        'dedicatedPage',
        'storefrontPreview',
        'backendPreview',
        'settingsPreview',
        'shop',
        'stories',
        'about',
        'bag',
        'autumnEssentials',
        'storeHero',
        'exploreCollection',
        'newSeason',
        'thoughtfulGoods',
        'euWithdrawal',
        'demoValidation',
        'testCases',
        'merchantBackend',
        'withdrawalRequests',
        'exportCsv',
        'totalRequests',
        'thisMonth',
        'pending',
        'needsReview',
        'requestedValue',
        'request',
        'customer',
        'items',
        'status',
        'view',
        'requestDetail',
        'additionalNote',
        'reject',
        'approve',
        'openShopifyOrder',
        'dashboard',
        'requests',
        'buttonSettings',
        'formSettings',
        'emailTemplate',
        'appConfiguration',
        'buttonAndForm',
        'buttonLabel',
        'buttonColor',
        'position',
        'bottomLeft',
        'bottomRight',
        'showFormModal',
        'enableWithdrawalPage',
        'saveSettings',
        'liveStorefrontPreview',
        'active',
        'settingsSaved',
        'requestApproved',
        'requestRejected',
        'justNow',
        'noAdditionalNote',
        'approved',
        'completed',
        'rejected',
        'orderWord',
      ];
      const UI_TRANSLATIONS = {
        en: [
          'Interactive app demo',
          'Install Now',
          'Frontend + backend',
          'Test the complete',
          'withdrawal journey.',
          'Validate order matching, load exact items, submit a withdrawal, and manage it from the merchant dashboard.',
          'Valid demo details',
          'Order',
          'Email',
          'Storefront',
          'Backend',
          'App settings',
          'Drawer form',
          'Dedicated page',
          'Storefront preview',
          'Shopify admin · Withdrawal requests',
          'Shopify admin · App settings',
          'Shop',
          'Stories',
          'About',
          'Bag',
          'Autumn essentials',
          'Objects made for slower days.',
          'Explore collection',
          'New season',
          'Thoughtful everyday goods.',
          'EU withdrawal',
          'Demo validation',
          'Test cases',
          'Merchant backend',
          'Withdrawal requests',
          'Export CSV',
          'Total requests',
          'This month',
          'Pending',
          'Needs review',
          'Requested value',
          'Request',
          'Customer',
          'Items',
          'Status',
          'View',
          'Request detail',
          'Additional note',
          'Reject',
          'Approve',
          'Open Shopify order',
          'Dashboard',
          'Requests',
          'Button settings',
          'Form settings',
          'Email template',
          'App configuration',
          'Button & form',
          'Button label',
          'Button color',
          'Position',
          'Bottom left',
          'Bottom right',
          'Show form in modal',
          'Enable withdrawal page',
          'Save settings',
          'Live storefront preview',
          'Active',
          'Settings saved successfully.',
          'Request approved.',
          'Request rejected.',
          'Just now',
          'No additional note.',
          'Approved',
          'Completed',
          'Rejected',
          'Order',
        ],
        de: [
          'Interaktive App-Demo',
          'Jetzt installieren',
          'Frontend + Backend',
          'Testen Sie die gesamte',
          'Widerrufsreise.',
          'Prüfen Sie Bestelldaten, laden Sie Artikel, senden Sie einen Widerruf und verwalten Sie ihn im Händler-Dashboard.',
          'Gültige Demo-Daten',
          'Bestellung',
          'E-Mail',
          'Storefront',
          'Backend',
          'App-Einstellungen',
          'Popup-Formular',
          'Eigene Seite',
          'Storefront-Vorschau',
          'Shopify-Admin · Widerrufsanträge',
          'Shopify-Admin · App-Einstellungen',
          'Shop',
          'Geschichten',
          'Über uns',
          'Warenkorb',
          'Herbst-Essentials',
          'Objekte für ruhigere Tage.',
          'Kollektion entdecken',
          'Neue Saison',
          'Durchdachte Alltagsprodukte.',
          'EU-Widerruf',
          'Demo-Prüfung',
          'Testfälle',
          'Händler-Backend',
          'Widerrufsanträge',
          'CSV exportieren',
          'Anträge gesamt',
          'Dieser Monat',
          'Ausstehend',
          'Prüfung nötig',
          'Angefragter Wert',
          'Antrag',
          'Kunde',
          'Artikel',
          'Status',
          'Ansehen',
          'Antragsdetails',
          'Zusätzliche Anmerkung',
          'Ablehnen',
          'Genehmigen',
          'Shopify-Bestellung öffnen',
          'Dashboard',
          'Anträge',
          'Button-Einstellungen',
          'Formular-Einstellungen',
          'E-Mail-Vorlage',
          'App-Konfiguration',
          'Button & Formular',
          'Button-Beschriftung',
          'Button-Farbe',
          'Position',
          'Unten links',
          'Unten rechts',
          'Formular im Popup anzeigen',
          'Widerrufsseite aktivieren',
          'Einstellungen speichern',
          'Live-Storefront-Vorschau',
          'Aktiv',
          'Einstellungen erfolgreich gespeichert.',
          'Antrag genehmigt.',
          'Antrag abgelehnt.',
          'Gerade eben',
          'Keine zusätzliche Anmerkung.',
          'Genehmigt',
          'Abgeschlossen',
          'Abgelehnt',
          'Bestellung',
        ],
        nl: [
          'Interactieve appdemo',
          'Nu installeren',
          'Frontend + backend',
          'Test het volledige',
          'herroepingsproces.',
          'Controleer bestellingen, laad artikelen, dien een herroeping in en beheer deze in het dashboard.',
          'Geldige demogegevens',
          'Bestelling',
          'E-mail',
          'Webshop',
          'Backend',
          'App-instellingen',
          'Ladeformulier',
          'Aparte pagina',
          'Webshopvoorbeeld',
          'Shopify-beheer · Herroepingsverzoeken',
          'Shopify-beheer · App-instellingen',
          'Winkel',
          'Verhalen',
          'Over ons',
          'Tas',
          'Herfstfavorieten',
          'Objecten voor rustige dagen.',
          'Collectie bekijken',
          'Nieuw seizoen',
          'Doordachte dagelijkse producten.',
          'EU-herroeping',
          'Democontrole',
          'Testgevallen',
          'Handelaarsbeheer',
          'Herroepingsverzoeken',
          'CSV exporteren',
          'Totaal verzoeken',
          'Deze maand',
          'In behandeling',
          'Controle nodig',
          'Aangevraagde waarde',
          'Verzoek',
          'Klant',
          'Artikelen',
          'Status',
          'Bekijken',
          'Verzoekdetails',
          'Aanvullende opmerking',
          'Afwijzen',
          'Goedkeuren',
          'Shopify-bestelling openen',
          'Dashboard',
          'Verzoeken',
          'Knopinstellingen',
          'Formulierinstellingen',
          'E-mailsjabloon',
          'App-configuratie',
          'Knop en formulier',
          'Knoptekst',
          'Knopkleur',
          'Positie',
          'Linksonder',
          'Rechtsonder',
          'Formulier in pop-up tonen',
          'Herroepingspagina inschakelen',
          'Instellingen opslaan',
          'Live webshopvoorbeeld',
          'Actief',
          'Instellingen opgeslagen.',
          'Verzoek goedgekeurd.',
          'Verzoek afgewezen.',
          'Zojuist',
          'Geen aanvullende opmerking.',
          'Goedgekeurd',
          'Voltooid',
          'Afgewezen',
          'Bestelling',
        ],
        fr: [
          'Démo interactive',
          'Installer maintenant',
          'Frontend + backend',
          'Testez tout le',
          'parcours de rétractation.',
          'Vérifiez la commande, chargez les articles, envoyez une demande et gérez-la depuis le tableau marchand.',
          'Données de démo valides',
          'Commande',
          'E-mail',
          'Boutique',
          'Backend',
          'Paramètres de l’app',
          'Formulaire tiroir',
          'Page dédiée',
          'Aperçu boutique',
          'Admin Shopify · Demandes de rétractation',
          'Admin Shopify · Paramètres de l’app',
          'Boutique',
          'Histoires',
          'À propos',
          'Panier',
          'Essentiels d’automne',
          'Des objets pour des journées plus calmes.',
          'Voir la collection',
          'Nouvelle saison',
          'Des objets utiles au quotidien.',
          'Rétractation UE',
          'Validation de démo',
          'Cas de test',
          'Espace marchand',
          'Demandes de rétractation',
          'Exporter CSV',
          'Total des demandes',
          'Ce mois-ci',
          'En attente',
          'À examiner',
          'Valeur demandée',
          'Demande',
          'Client',
          'Articles',
          'Statut',
          'Voir',
          'Détail de la demande',
          'Note supplémentaire',
          'Refuser',
          'Approuver',
          'Ouvrir la commande Shopify',
          'Tableau de bord',
          'Demandes',
          'Paramètres du bouton',
          'Paramètres du formulaire',
          'Modèle d’e-mail',
          'Configuration de l’app',
          'Bouton et formulaire',
          'Libellé du bouton',
          'Couleur du bouton',
          'Position',
          'En bas à gauche',
          'En bas à droite',
          'Afficher dans une fenêtre',
          'Activer la page de rétractation',
          'Enregistrer',
          'Aperçu boutique en direct',
          'Actif',
          'Paramètres enregistrés.',
          'Demande approuvée.',
          'Demande refusée.',
          'À l’instant',
          'Aucune note supplémentaire.',
          'Approuvée',
          'Terminée',
          'Refusée',
          'Commande',
        ],
        el: [
          'Διαδραστική επίδειξη εφαρμογής',
          'Εγκατάσταση τώρα',
          'Frontend + backend',
          'Δοκιμάστε ολόκληρη τη',
          'διαδρομή υπαναχώρησης.',
          'Επαληθεύστε την παραγγελία, φορτώστε προϊόντα, υποβάλετε αίτημα και διαχειριστείτε το από τον πίνακα εμπόρου.',
          'Έγκυρα στοιχεία επίδειξης',
          'Παραγγελία',
          'Email',
          'Κατάστημα',
          'Backend',
          'Ρυθμίσεις εφαρμογής',
          'Φόρμα συρταριού',
          'Ξεχωριστή σελίδα',
          'Προεπισκόπηση καταστήματος',
          'Διαχείριση Shopify · Αιτήματα',
          'Διαχείριση Shopify · Ρυθμίσεις',
          'Κατάστημα',
          'Ιστορίες',
          'Σχετικά',
          'Τσάντα',
          'Φθινοπωρινά βασικά',
          'Αντικείμενα για πιο ήρεμες ημέρες.',
          'Προβολή συλλογής',
          'Νέα σεζόν',
          'Προσεγμένα καθημερινά προϊόντα.',
          'Υπαναχώρηση ΕΕ',
          'Έλεγχος επίδειξης',
          'Περιπτώσεις δοκιμής',
          'Πίνακας εμπόρου',
          'Αιτήματα υπαναχώρησης',
          'Εξαγωγή CSV',
          'Σύνολο αιτημάτων',
          'Αυτόν τον μήνα',
          'Σε αναμονή',
          'Χρειάζεται έλεγχο',
          'Αξία αιτήματος',
          'Αίτημα',
          'Πελάτης',
          'Προϊόντα',
          'Κατάσταση',
          'Προβολή',
          'Λεπτομέρειες αιτήματος',
          'Πρόσθετη σημείωση',
          'Απόρριψη',
          'Έγκριση',
          'Άνοιγμα παραγγελίας Shopify',
          'Πίνακας',
          'Αιτήματα',
          'Ρυθμίσεις κουμπιού',
          'Ρυθμίσεις φόρμας',
          'Πρότυπο email',
          'Ρύθμιση εφαρμογής',
          'Κουμπί και φόρμα',
          'Κείμενο κουμπιού',
          'Χρώμα κουμπιού',
          'Θέση',
          'Κάτω αριστερά',
          'Κάτω δεξιά',
          'Εμφάνιση φόρμας σε popup',
          'Ενεργοποίηση σελίδας',
          'Αποθήκευση ρυθμίσεων',
          'Ζωντανή προεπισκόπηση',
          'Ενεργό',
          'Οι ρυθμίσεις αποθηκεύτηκαν.',
          'Το αίτημα εγκρίθηκε.',
          'Το αίτημα απορρίφθηκε.',
          'Μόλις τώρα',
          'Χωρίς πρόσθετη σημείωση.',
          'Εγκρίθηκε',
          'Ολοκληρώθηκε',
          'Απορρίφθηκε',
          'Παραγγελία',
        ],
        fi: [
          'Interaktiivinen sovellusdemo',
          'Asenna nyt',
          'Käyttöliittymä + hallinta',
          'Testaa koko',
          'peruuttamisprosessi.',
          'Tarkista tilaus, lataa tuotteet, lähetä pyyntö ja hallitse sitä kauppiaan näkymässä.',
          'Kelvolliset demotiedot',
          'Tilaus',
          'Sähköposti',
          'Kauppa',
          'Hallinta',
          'Sovellusasetukset',
          'Sivupaneelilomake',
          'Erillinen sivu',
          'Kaupan esikatselu',
          'Shopify-hallinta · Peruuttamispyynnöt',
          'Shopify-hallinta · Sovellusasetukset',
          'Kauppa',
          'Tarinat',
          'Tietoa',
          'Kassi',
          'Syksyn suosikit',
          'Esineitä rauhallisempiin päiviin.',
          'Tutustu kokoelmaan',
          'Uusi kausi',
          'Harkittuja arjen tuotteita.',
          'EU-peruuttaminen',
          'Demon tarkistus',
          'Testitapaukset',
          'Kauppiaan hallinta',
          'Peruuttamispyynnöt',
          'Vie CSV',
          'Pyyntöjä yhteensä',
          'Tässä kuussa',
          'Odottaa',
          'Tarkistettava',
          'Pyydetty arvo',
          'Pyyntö',
          'Asiakas',
          'Tuotteet',
          'Tila',
          'Näytä',
          'Pyynnön tiedot',
          'Lisätiedot',
          'Hylkää',
          'Hyväksy',
          'Avaa Shopify-tilaus',
          'Hallintapaneeli',
          'Pyynnöt',
          'Painikkeen asetukset',
          'Lomakkeen asetukset',
          'Sähköpostimalli',
          'Sovelluksen määritys',
          'Painike ja lomake',
          'Painikkeen teksti',
          'Painikkeen väri',
          'Sijainti',
          'Alhaalla vasemmalla',
          'Alhaalla oikealla',
          'Näytä lomake ikkunassa',
          'Ota peruuttamissivu käyttöön',
          'Tallenna asetukset',
          'Kaupan live-esikatselu',
          'Aktiivinen',
          'Asetukset tallennettu.',
          'Pyyntö hyväksytty.',
          'Pyyntö hylätty.',
          'Juuri nyt',
          'Ei lisätietoja.',
          'Hyväksytty',
          'Valmis',
          'Hylätty',
          'Tilaus',
        ],
        sv: [
          'Interaktiv appdemo',
          'Installera nu',
          'Frontend + backend',
          'Testa hela',
          'ångerrättsresan.',
          'Verifiera ordern, ladda artiklar, skicka en begäran och hantera den i handlarvyn.',
          'Giltiga demouppgifter',
          'Order',
          'E-post',
          'Butik',
          'Backend',
          'Appinställningar',
          'Lådformulär',
          'Egen sida',
          'Butiksförhandsvisning',
          'Shopify-admin · Ångerbegäranden',
          'Shopify-admin · Appinställningar',
          'Butik',
          'Berättelser',
          'Om oss',
          'Kasse',
          'Höstfavoriter',
          'Föremål för lugnare dagar.',
          'Utforska kollektionen',
          'Ny säsong',
          'Genomtänkta vardagsvaror.',
          'EU-ånger',
          'Demokontroll',
          'Testfall',
          'Handlarvy',
          'Ångerbegäranden',
          'Exportera CSV',
          'Totalt antal',
          'Denna månad',
          'Väntar',
          'Behöver granskas',
          'Begärt värde',
          'Begäran',
          'Kund',
          'Artiklar',
          'Status',
          'Visa',
          'Begärandedetaljer',
          'Ytterligare kommentar',
          'Avvisa',
          'Godkänn',
          'Öppna Shopify-order',
          'Instrumentpanel',
          'Begäranden',
          'Knappinställningar',
          'Formulärinställningar',
          'E-postmall',
          'Appkonfiguration',
          'Knapp och formulär',
          'Knapptext',
          'Knappfärg',
          'Position',
          'Nere till vänster',
          'Nere till höger',
          'Visa formulär i popup',
          'Aktivera ångersida',
          'Spara inställningar',
          'Liveförhandsvisning',
          'Aktiv',
          'Inställningarna sparades.',
          'Begäran godkänd.',
          'Begäran avvisad.',
          'Just nu',
          'Ingen ytterligare kommentar.',
          'Godkänd',
          'Slutförd',
          'Avvisad',
          'Order',
        ],
        hu: [
          'Interaktív alkalmazásdemó',
          'Telepítés most',
          'Frontend + backend',
          'Tesztelje a teljes',
          'elállási folyamatot.',
          'Ellenőrizze a rendelést, töltse be a termékeket, küldje el a kérelmet és kezelje a kereskedői felületen.',
          'Érvényes demóadatok',
          'Rendelés',
          'E-mail',
          'Webáruház',
          'Backend',
          'Alkalmazásbeállítások',
          'Oldalsó paneles űrlap',
          'Külön oldal',
          'Webáruház előnézet',
          'Shopify admin · Elállási kérelmek',
          'Shopify admin · Alkalmazásbeállítások',
          'Bolt',
          'Történetek',
          'Rólunk',
          'Kosár',
          'Őszi alapdarabok',
          'Tárgyak nyugodtabb napokra.',
          'Kollekció megtekintése',
          'Új szezon',
          'Átgondolt mindennapi termékek.',
          'EU-elállás',
          'Demóellenőrzés',
          'Teszt esetek',
          'Kereskedői backend',
          'Elállási kérelmek',
          'CSV exportálása',
          'Összes kérelem',
          'Ebben a hónapban',
          'Függőben',
          'Ellenőrzést igényel',
          'Kért érték',
          'Kérelem',
          'Vásárló',
          'Termékek',
          'Állapot',
          'Megtekintés',
          'Kérelem részletei',
          'További megjegyzés',
          'Elutasítás',
          'Jóváhagyás',
          'Shopify-rendelés megnyitása',
          'Vezérlőpult',
          'Kérelmek',
          'Gombbeállítások',
          'Űrlapbeállítások',
          'E-mail-sablon',
          'Alkalmazás konfiguráció',
          'Gomb és űrlap',
          'Gomb felirata',
          'Gomb színe',
          'Pozíció',
          'Bal alsó',
          'Jobb alsó',
          'Űrlap megjelenítése felugró ablakban',
          'Elállási oldal engedélyezése',
          'Beállítások mentése',
          'Élő webáruház-előnézet',
          'Aktív',
          'Beállítások mentve.',
          'Kérelem jóváhagyva.',
          'Kérelem elutasítva.',
          'Épp most',
          'Nincs további megjegyzés.',
          'Jóváhagyva',
          'Befejezve',
          'Elutasítva',
          'Rendelés',
        ],
        ga: [
          'Taispeántas idirghníomhach',
          'Suiteáil Anois',
          'Frontend + backend',
          'Tástáil an',
          'turas tarraingthe siar.',
          'Fíoraigh an t-ordú, lódáil míreanna, seol iarratas agus bainistigh é sa deais trádálaí.',
          'Sonraí bailí taispeána',
          'Ordú',
          'Ríomhphost',
          'Siopa',
          'Cúlchóras',
          'Socruithe aip',
          'Foirm tarraiceáin',
          'Leathanach tiomnaithe',
          'Réamhamharc siopa',
          'Riarachán Shopify · Iarratais',
          'Riarachán Shopify · Socruithe',
          'Siopa',
          'Scéalta',
          'Fúinn',
          'Mála',
          'Bunriachtanais an fhómhair',
          'Rudaí do laethanta níos ciúine.',
          'Féach ar an mbailiúchán',
          'Séasúr nua',
          'Earraí laethúla smaointeacha.',
          'Tarraingt siar AE',
          'Fíorú taispeána',
          'Cásanna tástála',
          'Cúlchóras trádálaí',
          'Iarratais tarraingthe siar',
          'Easpórtáil CSV',
          'Iarratais iomlána',
          'An mhí seo',
          'Ar feitheamh',
          'Le hathbhreithniú',
          'Luach iarrtha',
          'Iarratas',
          'Custaiméir',
          'Míreanna',
          'Stádas',
          'Féach',
          'Sonraí iarratais',
          'Nóta breise',
          'Diúltaigh',
          'Ceadaigh',
          'Oscail ordú Shopify',
          'Deais',
          'Iarratais',
          'Socruithe cnaipe',
          'Socruithe foirme',
          'Teimpléad ríomhphoist',
          'Cumraíocht aip',
          'Cnaipe agus foirm',
          'Lipéad cnaipe',
          'Dath cnaipe',
          'Suíomh',
          'Bun ar chlé',
          'Bun ar dheis',
          'Taispeáin i bhfuinneog aníos',
          'Cumasaigh leathanach',
          'Sábháil socruithe',
          'Réamhamharc beo',
          'Gníomhach',
          'Sábháladh na socruithe.',
          'Ceadaíodh an t-iarratas.',
          'Diúltaíodh don iarratas.',
          'Díreach anois',
          'Gan nóta breise.',
          'Ceadaithe',
          'Críochnaithe',
          'Diúltaithe',
          'Ordú',
        ],
        it: [
          'Demo interattiva',
          'Installa ora',
          'Frontend + backend',
          'Prova l’intero',
          'percorso di recesso.',
          'Verifica l’ordine, carica gli articoli, invia la richiesta e gestiscila dal pannello commerciante.',
          'Dati demo validi',
          'Ordine',
          'E-mail',
          'Negozio',
          'Backend',
          'Impostazioni app',
          'Modulo a cassetto',
          'Pagina dedicata',
          'Anteprima negozio',
          'Admin Shopify · Richieste di recesso',
          'Admin Shopify · Impostazioni app',
          'Negozio',
          'Storie',
          'Chi siamo',
          'Carrello',
          'Essenziali d’autunno',
          'Oggetti per giornate più lente.',
          'Esplora la collezione',
          'Nuova stagione',
          'Prodotti quotidiani ben pensati.',
          'Recesso UE',
          'Verifica demo',
          'Casi di test',
          'Backend commerciante',
          'Richieste di recesso',
          'Esporta CSV',
          'Richieste totali',
          'Questo mese',
          'In attesa',
          'Da verificare',
          'Valore richiesto',
          'Richiesta',
          'Cliente',
          'Articoli',
          'Stato',
          'Visualizza',
          'Dettagli richiesta',
          'Nota aggiuntiva',
          'Rifiuta',
          'Approva',
          'Apri ordine Shopify',
          'Dashboard',
          'Richieste',
          'Impostazioni pulsante',
          'Impostazioni modulo',
          'Modello e-mail',
          'Configurazione app',
          'Pulsante e modulo',
          'Testo pulsante',
          'Colore pulsante',
          'Posizione',
          'In basso a sinistra',
          'In basso a destra',
          'Mostra modulo nel popup',
          'Abilita pagina di recesso',
          'Salva impostazioni',
          'Anteprima negozio live',
          'Attivo',
          'Impostazioni salvate.',
          'Richiesta approvata.',
          'Richiesta rifiutata.',
          'Adesso',
          'Nessuna nota aggiuntiva.',
          'Approvata',
          'Completata',
          'Rifiutata',
          'Ordine',
        ],
        pl: [
          'Interaktywne demo aplikacji',
          'Zainstaluj teraz',
          'Frontend + backend',
          'Przetestuj cały',
          'proces odstąpienia.',
          'Zweryfikuj zamówienie, wczytaj produkty, wyślij wniosek i zarządzaj nim w panelu sprzedawcy.',
          'Prawidłowe dane demo',
          'Zamówienie',
          'E-mail',
          'Sklep',
          'Backend',
          'Ustawienia aplikacji',
          'Formularz boczny',
          'Osobna strona',
          'Podgląd sklepu',
          'Panel Shopify · Wnioski',
          'Panel Shopify · Ustawienia',
          'Sklep',
          'Historie',
          'O nas',
          'Koszyk',
          'Jesienne podstawy',
          'Przedmioty na spokojniejsze dni.',
          'Zobacz kolekcję',
          'Nowy sezon',
          'Przemyślane produkty codzienne.',
          'Odstąpienie UE',
          'Weryfikacja demo',
          'Przypadki testowe',
          'Panel sprzedawcy',
          'Wnioski o odstąpienie',
          'Eksportuj CSV',
          'Wszystkie wnioski',
          'W tym miesiącu',
          'Oczekujące',
          'Wymaga sprawdzenia',
          'Wartość wniosków',
          'Wniosek',
          'Klient',
          'Produkty',
          'Status',
          'Zobacz',
          'Szczegóły wniosku',
          'Dodatkowa uwaga',
          'Odrzuć',
          'Zatwierdź',
          'Otwórz zamówienie Shopify',
          'Pulpit',
          'Wnioski',
          'Ustawienia przycisku',
          'Ustawienia formularza',
          'Szablon e-mail',
          'Konfiguracja aplikacji',
          'Przycisk i formularz',
          'Etykieta przycisku',
          'Kolor przycisku',
          'Pozycja',
          'Lewy dół',
          'Prawy dół',
          'Pokaż formularz w popupie',
          'Włącz stronę odstąpienia',
          'Zapisz ustawienia',
          'Podgląd sklepu na żywo',
          'Aktywne',
          'Ustawienia zapisane.',
          'Wniosek zatwierdzony.',
          'Wniosek odrzucony.',
          'Przed chwilą',
          'Brak dodatkowej uwagi.',
          'Zatwierdzony',
          'Zakończony',
          'Odrzucony',
          'Zamówienie',
        ],
        ro: [
          'Demo interactiv',
          'Instalează acum',
          'Frontend + backend',
          'Testează întregul',
          'proces de retragere.',
          'Verifică comanda, încarcă produsele, trimite cererea și gestioneaz-o din panoul comerciantului.',
          'Date demo valide',
          'Comandă',
          'E-mail',
          'Magazin',
          'Backend',
          'Setări aplicație',
          'Formular lateral',
          'Pagină dedicată',
          'Previzualizare magazin',
          'Admin Shopify · Cereri',
          'Admin Shopify · Setări',
          'Magazin',
          'Povești',
          'Despre noi',
          'Coș',
          'Esențiale de toamnă',
          'Obiecte pentru zile mai liniștite.',
          'Explorează colecția',
          'Sezon nou',
          'Produse cotidiene bine gândite.',
          'Retragere UE',
          'Validare demo',
          'Cazuri de test',
          'Backend comerciant',
          'Cereri de retragere',
          'Exportă CSV',
          'Total cereri',
          'Luna aceasta',
          'În așteptare',
          'Necesită verificare',
          'Valoare solicitată',
          'Cerere',
          'Client',
          'Produse',
          'Stare',
          'Vezi',
          'Detalii cerere',
          'Notă suplimentară',
          'Respinge',
          'Aprobă',
          'Deschide comanda Shopify',
          'Panou',
          'Cereri',
          'Setări buton',
          'Setări formular',
          'Șablon e-mail',
          'Configurare aplicație',
          'Buton și formular',
          'Text buton',
          'Culoare buton',
          'Poziție',
          'Jos stânga',
          'Jos dreapta',
          'Afișează formularul în popup',
          'Activează pagina de retragere',
          'Salvează setările',
          'Previzualizare live',
          'Activ',
          'Setările au fost salvate.',
          'Cerere aprobată.',
          'Cerere respinsă.',
          'Chiar acum',
          'Fără notă suplimentară.',
          'Aprobată',
          'Finalizată',
          'Respinsă',
          'Comandă',
        ],
        pt: [
          'Demo interativa',
          'Instalar agora',
          'Frontend + backend',
          'Teste todo o',
          'processo de livre resolução.',
          'Verifique a encomenda, carregue os artigos, envie o pedido e faça a gestão no painel do comerciante.',
          'Dados de demo válidos',
          'Encomenda',
          'E-mail',
          'Loja',
          'Backend',
          'Definições da aplicação',
          'Formulário lateral',
          'Página dedicada',
          'Pré-visualização da loja',
          'Admin Shopify · Pedidos',
          'Admin Shopify · Definições',
          'Loja',
          'Histórias',
          'Sobre',
          'Carrinho',
          'Essenciais de outono',
          'Objetos para dias mais tranquilos.',
          'Explorar coleção',
          'Nova estação',
          'Produtos do dia a dia bem pensados.',
          'Livre resolução UE',
          'Validação da demo',
          'Casos de teste',
          'Backend do comerciante',
          'Pedidos de livre resolução',
          'Exportar CSV',
          'Total de pedidos',
          'Este mês',
          'Pendente',
          'Requer análise',
          'Valor solicitado',
          'Pedido',
          'Cliente',
          'Artigos',
          'Estado',
          'Ver',
          'Detalhes do pedido',
          'Nota adicional',
          'Rejeitar',
          'Aprovar',
          'Abrir encomenda Shopify',
          'Painel',
          'Pedidos',
          'Definições do botão',
          'Definições do formulário',
          'Modelo de e-mail',
          'Configuração da aplicação',
          'Botão e formulário',
          'Texto do botão',
          'Cor do botão',
          'Posição',
          'Inferior esquerdo',
          'Inferior direito',
          'Mostrar formulário em popup',
          'Ativar página de livre resolução',
          'Guardar definições',
          'Pré-visualização ao vivo',
          'Ativo',
          'Definições guardadas.',
          'Pedido aprovado.',
          'Pedido rejeitado.',
          'Agora',
          'Sem nota adicional.',
          'Aprovado',
          'Concluído',
          'Rejeitado',
          'Encomenda',
        ],
        es: [
          'Demo interactiva',
          'Instalar ahora',
          'Frontend + backend',
          'Prueba todo el',
          'proceso de desistimiento.',
          'Verifica el pedido, carga los artículos, envía la solicitud y gestiónala desde el panel del comerciante.',
          'Datos de demo válidos',
          'Pedido',
          'Correo',
          'Tienda',
          'Backend',
          'Ajustes de la app',
          'Formulario lateral',
          'Página dedicada',
          'Vista previa de tienda',
          'Admin Shopify · Solicitudes',
          'Admin Shopify · Ajustes',
          'Tienda',
          'Historias',
          'Nosotros',
          'Carrito',
          'Esenciales de otoño',
          'Objetos para días más tranquilos.',
          'Explorar colección',
          'Nueva temporada',
          'Productos cotidianos bien pensados.',
          'Desistimiento UE',
          'Validación de demo',
          'Casos de prueba',
          'Backend del comerciante',
          'Solicitudes de desistimiento',
          'Exportar CSV',
          'Total de solicitudes',
          'Este mes',
          'Pendiente',
          'Requiere revisión',
          'Valor solicitado',
          'Solicitud',
          'Cliente',
          'Artículos',
          'Estado',
          'Ver',
          'Detalle de la solicitud',
          'Nota adicional',
          'Rechazar',
          'Aprobar',
          'Abrir pedido de Shopify',
          'Panel',
          'Solicitudes',
          'Ajustes del botón',
          'Ajustes del formulario',
          'Plantilla de correo',
          'Configuración de la app',
          'Botón y formulario',
          'Texto del botón',
          'Color del botón',
          'Posición',
          'Abajo a la izquierda',
          'Abajo a la derecha',
          'Mostrar formulario en ventana',
          'Activar página de desistimiento',
          'Guardar ajustes',
          'Vista previa en vivo',
          'Activo',
          'Ajustes guardados.',
          'Solicitud aprobada.',
          'Solicitud rechazada.',
          'Ahora mismo',
          'Sin nota adicional.',
          'Aprobada',
          'Completada',
          'Rechazada',
          'Pedido',
        ],
        cs: [
          'Interaktivní ukázka aplikace',
          'Nainstalovat nyní',
          'Frontend + backend',
          'Vyzkoušejte celý',
          'proces odstoupení.',
          'Ověřte objednávku, načtěte položky, odešlete žádost a spravujte ji v administraci.',
          'Platné demo údaje',
          'Objednávka',
          'E-mail',
          'Obchod',
          'Backend',
          'Nastavení aplikace',
          'Boční formulář',
          'Samostatná stránka',
          'Náhled obchodu',
          'Shopify admin · Žádosti',
          'Shopify admin · Nastavení',
          'Obchod',
          'Příběhy',
          'O nás',
          'Košík',
          'Podzimní základy',
          'Předměty pro klidnější dny.',
          'Prozkoumat kolekci',
          'Nová sezóna',
          'Promyšlené každodenní zboží.',
          'Odstoupení EU',
          'Ověření dema',
          'Testovací případy',
          'Administrace obchodníka',
          'Žádosti o odstoupení',
          'Export CSV',
          'Celkem žádostí',
          'Tento měsíc',
          'Čeká',
          'Vyžaduje kontrolu',
          'Požadovaná hodnota',
          'Žádost',
          'Zákazník',
          'Položky',
          'Stav',
          'Zobrazit',
          'Detail žádosti',
          'Doplňující poznámka',
          'Zamítnout',
          'Schválit',
          'Otevřít Shopify objednávku',
          'Přehled',
          'Žádosti',
          'Nastavení tlačítka',
          'Nastavení formuláře',
          'E-mailová šablona',
          'Konfigurace aplikace',
          'Tlačítko a formulář',
          'Text tlačítka',
          'Barva tlačítka',
          'Pozice',
          'Vlevo dole',
          'Vpravo dole',
          'Zobrazit formulář v okně',
          'Povolit stránku odstoupení',
          'Uložit nastavení',
          'Živý náhled obchodu',
          'Aktivní',
          'Nastavení uloženo.',
          'Žádost schválena.',
          'Žádost zamítnuta.',
          'Právě teď',
          'Bez doplňující poznámky.',
          'Schváleno',
          'Dokončeno',
          'Zamítnuto',
          'Objednávka',
        ],
        da: [
          'Interaktiv appdemo',
          'Installer nu',
          'Frontend + backend',
          'Test hele',
          'fortrydelsesrejsen.',
          'Bekræft ordren, indlæs varer, send en anmodning og administrer den i forhandlerpanelet.',
          'Gyldige demooplysninger',
          'Ordre',
          'E-mail',
          'Butik',
          'Backend',
          'Appindstillinger',
          'Sidepanelformular',
          'Dedikeret side',
          'Butiksvisning',
          'Shopify-admin · Anmodninger',
          'Shopify-admin · Indstillinger',
          'Butik',
          'Historier',
          'Om os',
          'Kurv',
          'Efterårets favoritter',
          'Ting til roligere dage.',
          'Se kollektionen',
          'Ny sæson',
          'Gennemtænkte hverdagsvarer.',
          'EU-fortrydelse',
          'Demokontrol',
          'Testsager',
          'Forhandlerbackend',
          'Fortrydelsesanmodninger',
          'Eksportér CSV',
          'Anmodninger i alt',
          'Denne måned',
          'Afventer',
          'Kræver gennemgang',
          'Anmodet værdi',
          'Anmodning',
          'Kunde',
          'Varer',
          'Status',
          'Vis',
          'Anmodningsdetaljer',
          'Yderligere note',
          'Afvis',
          'Godkend',
          'Åbn Shopify-ordre',
          'Dashboard',
          'Anmodninger',
          'Knapindstillinger',
          'Formularindstillinger',
          'E-mailskabelon',
          'Appkonfiguration',
          'Knap og formular',
          'Knaptekst',
          'Knapfarve',
          'Placering',
          'Nederst til venstre',
          'Nederst til højre',
          'Vis formular i popup',
          'Aktivér fortrydelsesside',
          'Gem indstillinger',
          'Live butiksvisning',
          'Aktiv',
          'Indstillinger gemt.',
          'Anmodning godkendt.',
          'Anmodning afvist.',
          'Lige nu',
          'Ingen yderligere note.',
          'Godkendt',
          'Fuldført',
          'Afvist',
          'Ordre',
        ],
        et: [
          'Interaktiivne rakenduse demo',
          'Installi kohe',
          'Esiosa + haldus',
          'Testige kogu',
          'taganemise teekonda.',
          'Kontrollige tellimust, laadige tooted, saatke taotlus ja hallake seda kaupmehe vaates.',
          'Kehtivad demoandmed',
          'Tellimus',
          'E-post',
          'Pood',
          'Haldus',
          'Rakenduse seaded',
          'Külgpaneeli vorm',
          'Eraldi leht',
          'Poe eelvaade',
          'Shopify haldus · Taotlused',
          'Shopify haldus · Seaded',
          'Pood',
          'Lood',
          'Meist',
          'Ostukorv',
          'Sügise põhitooted',
          'Esemed rahulikumateks päevadeks.',
          'Vaata kollektsiooni',
          'Uus hooaeg',
          'Läbimõeldud igapäevakaubad.',
          'EL-i taganemine',
          'Demo kontroll',
          'Testjuhud',
          'Kaupmehe haldus',
          'Taganemistaotlused',
          'Ekspordi CSV',
          'Taotlusi kokku',
          'Sel kuul',
          'Ootel',
          'Vajab kontrolli',
          'Taotletud väärtus',
          'Taotlus',
          'Klient',
          'Tooted',
          'Olek',
          'Vaata',
          'Taotluse üksikasjad',
          'Lisamärkus',
          'Lükka tagasi',
          'Kinnita',
          'Ava Shopify tellimus',
          'Töölaud',
          'Taotlused',
          'Nupu seaded',
          'Vormi seaded',
          'E-kirja mall',
          'Rakenduse seadistus',
          'Nupp ja vorm',
          'Nupu tekst',
          'Nupu värv',
          'Asukoht',
          'All vasakul',
          'All paremal',
          'Näita vormi hüpikaknas',
          'Luba taganemisleht',
          'Salvesta seaded',
          'Poe reaalajas eelvaade',
          'Aktiivne',
          'Seaded salvestatud.',
          'Taotlus kinnitatud.',
          'Taotlus tagasi lükatud.',
          'Just praegu',
          'Lisamärkus puudub.',
          'Kinnitatud',
          'Lõpetatud',
          'Tagasi lükatud',
          'Tellimus',
        ],
        lv: [
          'Interaktīva lietotnes demonstrācija',
          'Instalēt tūlīt',
          'Frontend + backend',
          'Izmēģiniet visu',
          'atteikuma procesu.',
          'Pārbaudiet pasūtījumu, ielādējiet preces, iesniedziet pieprasījumu un pārvaldiet to tirgotāja panelī.',
          'Derīgi demonstrācijas dati',
          'Pasūtījums',
          'E-pasts',
          'Veikals',
          'Backend',
          'Lietotnes iestatījumi',
          'Sānu paneļa forma',
          'Atsevišķa lapa',
          'Veikala priekšskatījums',
          'Shopify administrācija · Pieprasījumi',
          'Shopify administrācija · Iestatījumi',
          'Veikals',
          'Stāsti',
          'Par mums',
          'Grozs',
          'Rudens pamata preces',
          'Lietas mierīgākām dienām.',
          'Skatīt kolekciju',
          'Jaunā sezona',
          'Pārdomātas ikdienas preces.',
          'ES atteikums',
          'Demo pārbaude',
          'Testa gadījumi',
          'Tirgotāja backend',
          'Atteikuma pieprasījumi',
          'Eksportēt CSV',
          'Pieprasījumi kopā',
          'Šomēnes',
          'Gaida',
          'Jāpārskata',
          'Pieprasītā vērtība',
          'Pieprasījums',
          'Klients',
          'Preces',
          'Statuss',
          'Skatīt',
          'Pieprasījuma detaļas',
          'Papildu piezīme',
          'Noraidīt',
          'Apstiprināt',
          'Atvērt Shopify pasūtījumu',
          'Panelis',
          'Pieprasījumi',
          'Pogas iestatījumi',
          'Formas iestatījumi',
          'E-pasta veidne',
          'Lietotnes konfigurācija',
          'Poga un forma',
          'Pogas teksts',
          'Pogas krāsa',
          'Pozīcija',
          'Apakšā pa kreisi',
          'Apakšā pa labi',
          'Rādīt formu uznirstošā logā',
          'Iespējot atteikuma lapu',
          'Saglabāt iestatījumus',
          'Veikala tiešais priekšskatījums',
          'Aktīvs',
          'Iestatījumi saglabāti.',
          'Pieprasījums apstiprināts.',
          'Pieprasījums noraidīts.',
          'Tikko',
          'Nav papildu piezīmes.',
          'Apstiprināts',
          'Pabeigts',
          'Noraidīts',
          'Pasūtījums',
        ],
        lt: [
          'Interaktyvi programėlės demonstracija',
          'Įdiegti dabar',
          'Sąsaja + administravimas',
          'Išbandykite visą',
          'atsisakymo kelią.',
          'Patikrinkite užsakymą, įkelkite prekes, pateikite prašymą ir valdykite jį pardavėjo skydelyje.',
          'Galiojantys demo duomenys',
          'Užsakymas',
          'El. paštas',
          'Parduotuvė',
          'Administravimas',
          'Programėlės nustatymai',
          'Šoninio skydelio forma',
          'Atskiras puslapis',
          'Parduotuvės peržiūra',
          'Shopify administravimas · Prašymai',
          'Shopify administravimas · Nustatymai',
          'Parduotuvė',
          'Istorijos',
          'Apie mus',
          'Krepšelis',
          'Rudens pagrindai',
          'Daiktai ramesnėms dienoms.',
          'Peržiūrėti kolekciją',
          'Naujas sezonas',
          'Apgalvoti kasdieniai gaminiai.',
          'ES atsisakymas',
          'Demo patikra',
          'Testavimo atvejai',
          'Pardavėjo administravimas',
          'Atsisakymo prašymai',
          'Eksportuoti CSV',
          'Iš viso prašymų',
          'Šį mėnesį',
          'Laukiama',
          'Reikia peržiūrėti',
          'Prašoma vertė',
          'Prašymas',
          'Klientas',
          'Prekės',
          'Būsena',
          'Peržiūrėti',
          'Prašymo informacija',
          'Papildoma pastaba',
          'Atmesti',
          'Patvirtinti',
          'Atidaryti Shopify užsakymą',
          'Skydelis',
          'Prašymai',
          'Mygtuko nustatymai',
          'Formos nustatymai',
          'El. laiško šablonas',
          'Programėlės konfigūracija',
          'Mygtukas ir forma',
          'Mygtuko tekstas',
          'Mygtuko spalva',
          'Vieta',
          'Apačioje kairėje',
          'Apačioje dešinėje',
          'Rodyti formą lange',
          'Įjungti atsisakymo puslapį',
          'Išsaugoti nustatymus',
          'Tiesioginė parduotuvės peržiūra',
          'Aktyvu',
          'Nustatymai išsaugoti.',
          'Prašymas patvirtintas.',
          'Prašymas atmestas.',
          'Ką tik',
          'Nėra papildomos pastabos.',
          'Patvirtinta',
          'Baigta',
          'Atmesta',
          'Užsakymas',
        ],
        mt: [
          'Demo interattiva tal-app',
          'Installa Issa',
          'Frontend + backend',
          'Ittestja l-',
          'vjaġġ kollu tal-irtirar.',
          'Ivverifika l-ordni, ittella’ l-oġġetti, ibgħat talba u mmaniġġjaha mill-pannell tal-bejjiegħ.',
          'Dettalji validi tad-demo',
          'Ordni',
          'Email',
          'Ħanut',
          'Backend',
          'Settings tal-app',
          'Formola tal-ġenb',
          'Paġna ddedikata',
          'Previżjoni tal-ħanut',
          'Admin Shopify · Talbiet',
          'Admin Shopify · Settings',
          'Ħanut',
          'Stejjer',
          'Dwarna',
          'Basket',
          'Essenzjali tal-ħarifa',
          'Oġġetti għal jiem aktar kalmi.',
          'Ara l-kollezzjoni',
          'Staġun ġdid',
          'Oġġetti ta’ kuljum maħsuba tajjeb.',
          'Irtirar tal-UE',
          'Validazzjoni tad-demo',
          'Każijiet tat-test',
          'Backend tal-bejjiegħ',
          'Talbiet ta’ rtirar',
          'Esporta CSV',
          'Total ta’ talbiet',
          'Dan ix-xahar',
          'Pendenti',
          'Jeħtieġ reviżjoni',
          'Valur mitlub',
          'Talba',
          'Klijent',
          'Oġġetti',
          'Status',
          'Ara',
          'Dettalji tat-talba',
          'Nota addizzjonali',
          'Irrifjuta',
          'Approva',
          'Iftaħ l-ordni Shopify',
          'Dashboard',
          'Talbiet',
          'Settings tal-buttuna',
          'Settings tal-formola',
          'Mudell tal-email',
          'Konfigurazzjoni tal-app',
          'Buttuna u formola',
          'Test tal-buttuna',
          'Kulur tal-buttuna',
          'Pożizzjoni',
          'Isfel xellug',
          'Isfel lemin',
          'Uri l-formola f’popup',
          'Attiva l-paġna tal-irtirar',
          'Issejvja s-settings',
          'Previżjoni diretta tal-ħanut',
          'Attiv',
          'Is-settings ġew issejvjati.',
          'It-talba ġiet approvata.',
          'It-talba ġiet irrifjutata.',
          'Issa',
          'L-ebda nota addizzjonali.',
          'Approvat',
          'Lest',
          'Irrifjutat',
          'Ordni',
        ],
        sk: [
          'Interaktívna ukážka aplikácie',
          'Inštalovať teraz',
          'Frontend + backend',
          'Vyskúšajte celý',
          'proces odstúpenia.',
          'Overte objednávku, načítajte položky, odošlite žiadosť a spravujte ju v paneli obchodníka.',
          'Platné demo údaje',
          'Objednávka',
          'E-mail',
          'Obchod',
          'Backend',
          'Nastavenia aplikácie',
          'Bočný formulár',
          'Samostatná stránka',
          'Náhľad obchodu',
          'Shopify admin · Žiadosti',
          'Shopify admin · Nastavenia',
          'Obchod',
          'Príbehy',
          'O nás',
          'Košík',
          'Jesenné základy',
          'Predmety pre pokojnejšie dni.',
          'Preskúmať kolekciu',
          'Nová sezóna',
          'Premyslené každodenné produkty.',
          'Odstúpenie EÚ',
          'Overenie dema',
          'Testovacie prípady',
          'Backend obchodníka',
          'Žiadosti o odstúpenie',
          'Export CSV',
          'Žiadosti spolu',
          'Tento mesiac',
          'Čaká',
          'Vyžaduje kontrolu',
          'Požadovaná hodnota',
          'Žiadosť',
          'Zákazník',
          'Položky',
          'Stav',
          'Zobraziť',
          'Detail žiadosti',
          'Doplňujúca poznámka',
          'Zamietnuť',
          'Schváliť',
          'Otvoriť Shopify objednávku',
          'Prehľad',
          'Žiadosti',
          'Nastavenia tlačidla',
          'Nastavenia formulára',
          'E-mailová šablóna',
          'Konfigurácia aplikácie',
          'Tlačidlo a formulár',
          'Text tlačidla',
          'Farba tlačidla',
          'Pozícia',
          'Vľavo dole',
          'Vpravo dole',
          'Zobraziť formulár v okne',
          'Povoliť stránku odstúpenia',
          'Uložiť nastavenia',
          'Živý náhľad obchodu',
          'Aktívne',
          'Nastavenia uložené.',
          'Žiadosť schválená.',
          'Žiadosť zamietnutá.',
          'Práve teraz',
          'Bez doplňujúcej poznámky.',
          'Schválené',
          'Dokončené',
          'Zamietnuté',
          'Objednávka',
        ],
        sl: [
          'Interaktivna predstavitev aplikacije',
          'Namesti zdaj',
          'Frontend + backend',
          'Preizkusite celotno',
          'pot odstopa.',
          'Preverite naročilo, naložite izdelke, pošljite zahtevo in jo upravljajte v trgovskem vmesniku.',
          'Veljavni demo podatki',
          'Naročilo',
          'E-pošta',
          'Trgovina',
          'Zaledje',
          'Nastavitve aplikacije',
          'Stranski obrazec',
          'Namenska stran',
          'Predogled trgovine',
          'Shopify admin · Zahteve',
          'Shopify admin · Nastavitve',
          'Trgovina',
          'Zgodbe',
          'O nas',
          'Košarica',
          'Jesenske osnove',
          'Predmeti za mirnejše dni.',
          'Oglej si kolekcijo',
          'Nova sezona',
          'Premišljeni vsakdanji izdelki.',
          'Odstop EU',
          'Preverjanje predstavitve',
          'Testni primeri',
          'Trgovski backend',
          'Zahteve za odstop',
          'Izvozi CSV',
          'Skupaj zahtev',
          'Ta mesec',
          'V čakanju',
          'Potreben pregled',
          'Zahtevana vrednost',
          'Zahteva',
          'Stranka',
          'Izdelki',
          'Stanje',
          'Poglej',
          'Podrobnosti zahteve',
          'Dodatna opomba',
          'Zavrni',
          'Odobri',
          'Odpri Shopify naročilo',
          'Nadzorna plošča',
          'Zahteve',
          'Nastavitve gumba',
          'Nastavitve obrazca',
          'E-poštna predloga',
          'Konfiguracija aplikacije',
          'Gumb in obrazec',
          'Besedilo gumba',
          'Barva gumba',
          'Položaj',
          'Spodaj levo',
          'Spodaj desno',
          'Prikaži obrazec v pojavnem oknu',
          'Omogoči stran za odstop',
          'Shrani nastavitve',
          'Predogled trgovine v živo',
          'Aktivno',
          'Nastavitve shranjene.',
          'Zahteva odobrena.',
          'Zahteva zavrnjena.',
          'Pravkar',
          'Brez dodatne opombe.',
          'Odobreno',
          'Zaključeno',
          'Zavrnjeno',
          'Naročilo',
        ],
        hr: [
          'Interaktivni demo aplikacije',
          'Instaliraj odmah',
          'Frontend + backend',
          'Testirajte cijeli',
          'postupak odustajanja.',
          'Provjerite narudžbu, učitajte artikle, pošaljite zahtjev i upravljajte njime u sučelju trgovca.',
          'Važeći demo podaci',
          'Narudžba',
          'E-pošta',
          'Trgovina',
          'Backend',
          'Postavke aplikacije',
          'Bočni obrazac',
          'Posebna stranica',
          'Pregled trgovine',
          'Shopify admin · Zahtjevi',
          'Shopify admin · Postavke',
          'Trgovina',
          'Priče',
          'O nama',
          'Košarica',
          'Jesenske osnove',
          'Predmeti za mirnije dane.',
          'Istraži kolekciju',
          'Nova sezona',
          'Promišljeni svakodnevni proizvodi.',
          'EU odustajanje',
          'Provjera demoa',
          'Testni slučajevi',
          'Backend trgovca',
          'Zahtjevi za odustajanje',
          'Izvezi CSV',
          'Ukupno zahtjeva',
          'Ovaj mjesec',
          'Na čekanju',
          'Potrebna provjera',
          'Zatražena vrijednost',
          'Zahtjev',
          'Kupac',
          'Artikli',
          'Status',
          'Prikaži',
          'Detalji zahtjeva',
          'Dodatna napomena',
          'Odbij',
          'Odobri',
          'Otvori Shopify narudžbu',
          'Nadzorna ploča',
          'Zahtjevi',
          'Postavke gumba',
          'Postavke obrasca',
          'Predložak e-pošte',
          'Konfiguracija aplikacije',
          'Gumb i obrazac',
          'Tekst gumba',
          'Boja gumba',
          'Položaj',
          'Dolje lijevo',
          'Dolje desno',
          'Prikaži obrazac u skočnom prozoru',
          'Omogući stranicu za odustajanje',
          'Spremi postavke',
          'Pregled trgovine uživo',
          'Aktivno',
          'Postavke su spremljene.',
          'Zahtjev je odobren.',
          'Zahtjev je odbijen.',
          'Upravo sada',
          'Nema dodatne napomene.',
          'Odobreno',
          'Dovršeno',
          'Odbijeno',
          'Narudžba',
        ],
      };
      function ui(key) {
        const index = UI_KEYS.indexOf(key);
        const pack = UI_TRANSLATIONS[state.language] || UI_TRANSLATIONS.en;
        return index >= 0 ? pack[index] || UI_TRANSLATIONS.en[index] || key : key;
      }

      const state = {
        view: 'storefront',
        mode: 'popup',
        language: 'en',
        popup: false,
        verification: 'idle',
        orderId: '',
        email: '',
        fullName: '',
        note: '',
        selected: new Set(),
        submitted: false,
        settings: {
          buttonText: 'Withdraw Contract',
          color: '#000000',
          textColor: '#FFFFFF',
          position: 'right',
          verticalPadding: 13,
          horizontalPadding: 28,
          fontSize: 14,
          borderColor: '#000000',
          borderWidth: 1,
          radius: 5,
          pageEnabled: true,
          popupEnabled: true,
        },
        requests: [
          {
            id: 'DEMO-WR-014',
            order: '1048',
            customer: 'Emma Demo',
            email: 'emma.demo@example.com',
            items: 2,
            amount: '€89.00',
            date: 'Aug 6, 2026 · 15:21',
            status: 'Pending',
            note: 'I no longer need these products.',
          },
          {
            id: 'DEMO-WR-013',
            order: '#DEMO-1036',
            customer: 'Luca Sample',
            email: 'luca.sample@example.com',
            items: 1,
            amount: '€68.00',
            date: 'Aug 5, 2026 · 11:40',
            status: 'Approved',
            note: 'Ordered the wrong size.',
          },
          {
            id: 'DEMO-WR-012',
            order: '#DEMO-1024',
            customer: 'Mia Test',
            email: 'mia.test@example.com',
            items: 1,
            amount: '€42.00',
            date: 'Aug 3, 2026 · 09:18',
            status: 'Completed',
            note: 'No longer required.',
          },
        ],
        selectedRequest: 'DEMO-WR-014',
        adminPage: 'management',
        emailTemplate: 'confirmation',
        emailLocale: 'en',
      };

      const products = [
        { id: 'shirt', name: 'Essential Linen Shirt', variant: 'Natural / M', price: 54, color: '#DCCDBD' },
        { id: 'tote', name: 'Daily Canvas Tote', variant: 'Sand', price: 35, color: '#B99068' },
      ];

      const $ = (s, r = document) => r.querySelector(s);
      const $$ = (s, r = document) => [...r.querySelectorAll(s)];
      const tr = (k) => translations[state.language][k] || translations.en[k] || k;
      const esc = (v) =>
        String(v ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');

      const SITE_SECTION_KEYS = [
        'featuresEyebrow',
        'featuresTitle',
        'featuresIntro',
        'feature1Title',
        'feature1Text',
        'feature2Title',
        'feature2Text',
        'feature3Title',
        'feature3Text',
        'feature4Title',
        'feature4Text',
        'feature5Title',
        'feature5Text',
        'feature6Title',
        'feature6Text',
        'plansEyebrow',
        'plansTitle',
        'plansIntro',
        'freePlan',
        'foreverLabel',
        'freePlanCaption',
        'freeFeature1',
        'freeFeature2',
        'freeFeature3',
        'freeFeature4',
        'freeFeature5',
        'startFree',
        'recommended',
        'proPlan',
        'perMonth',
        'proPlanCaption',
        'proFeature1',
        'proFeature2',
        'proFeature3',
        'proFeature4',
        'proFeature5',
        'startTrial',
        'faqEyebrow',
        'faqTitle',
        'faq1Question',
        'faq1Answer',
        'faq2Question',
        'faq2Answer',
        'faq3Question',
        'faq3Answer',
        'faq4Question',
        'faq4Answer',
        'faq5Question',
        'faq5Answer',
        'footerText',
        'footerFeatures',
        'footerPlans',
        'footerFaq',
        'footerDemo',
        'footerCopyright',
        'footerSupport',
      ];
      const SITE_SECTION_I18N = {
        en: [
          'App features',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'App plans',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'Questions merchants usually ask.',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'FAQ',
          'Live demo',
          '© 2026 Slash Themes. All rights reserved.',
          'Support: support@slashthemes.com',
        ],
        de: [
          'App-Funktionen',
          'Alles für einen klaren Widerrufsprozess.',
          'Bieten Sie Kunden einen einfachen Widerruf und verwalten Sie jede Anfrage übersichtlich.',
          'Fester Widerrufsbutton',
          'Halten Sie die Widerrufsaktion sichtbar und passen Sie das Erscheinungsbild direkt im Demo an.',
          'Drawer- und Seitenformular',
          'Bieten Sie einen rechten Drawer oder eine eigene Widerrufsseite an.',
          'Live-Bestellprüfung',
          'Bestellnummer und E-Mail werden sofort geprüft, bevor berechtigte Artikel erscheinen.',
          'Shopify-ähnliche Verwaltung',
          'Anfragen prüfen, betroffene Artikel ansehen und Entscheidungen im App-Backend verwalten.',
          'E-Mail-Vorlageneditor',
          'Bestätigungs-, Genehmigungs- und Ablehnungs-E-Mails in unterstützten Sprachen vorbereiten.',
          'Erlebnis in 23 Sprachen',
          'Storefront, Formulare, Backend-Steuerung und Demo über einen Selektor übersetzen.',
          'App-Tarife',
          'Wählen Sie den passenden Tarif für Ihren Shop.',
          'Starten Sie mit dem wesentlichen Widerrufsprozess und erweitern Sie bei Bedarf.',
          'Kostenlos',
          'Dauerhaft',
          'Für Shops, die mit elektronischen Widerrufen starten.',
          'Fester Widerrufsbutton',
          'Drawer- und Seitenformular',
          'Bestell- und E-Mail-Prüfung',
          'Dashboard für Anfragen',
          'Mehrsprachiges Kundenerlebnis',
          'Kostenlos starten',
          'Empfohlen',
          'Pro',
          ' / Monat',
          'Für Händler mit erweiterten Abläufen und Automatisierung.',
          'Alles aus Kostenlos',
          'Genehmigungs- und Ablehnungs-E-Mails',
          'Automatische Shopify-Rückgabeanfrage',
          'Erweiterte Regeln und Automatisierung',
          'Eigenes CSS und Rechtseinstellungen',
          'Kostenlos testen',
          'FAQ',
          'Häufige Fragen von Händlern.',
          'Muss sich der Kunde anmelden?',
          'Nein. Kunden können mit Name, E-Mail und Bestellnummer ohne Konto einen Widerruf senden.',
          'Wie werden Bestelldaten geprüft?',
          'Die App prüft Bestellnummer und Kunden-E-Mail. Artikel erscheinen erst nach erfolgreichem Abgleich.',
          'Kann ich Drawer und eigene Seite verwenden?',
          'Ja. Das Demo enthält beide Varianten, damit Händler das passende Format prüfen können.',
          'Welche Sprachen werden unterstützt?',
          'Das Demo unterstützt 23 europäische Sprachen im Storefront, Formular und Backend.',
          'Kann der feste Button an mein Theme angepasst werden?',
          'Ja. Text, Ausrichtung, Abstände, Farben, Schriftgröße, Rahmen und Radius sind live anpassbar.',
          'Eine vollständige interaktive Vorschau des Kundenwiderrufs und Händlerprozesses.',
          'Funktionen',
          'Tarife',
          'FAQ',
          'Live-Demo',
          '© 2026 Slash Themes. Alle Rechte vorbehalten.',
          'Support: support@slashthemes.com',
        ],
        nl: [
          'App-functies',
          'Alles voor een duidelijk herroepingsproces.',
          'Bied klanten een eenvoudig proces en houd elk verzoek georganiseerd.',
          'Vaste herroepingsknop',
          'Houd de actie zichtbaar en pas de knop live aan.',
          'Lade- en paginaformulier',
          'Gebruik een zijlade of aparte herroepingspagina.',
          'Live bestelcontrole',
          'Controleer bestelnummer en e-mail voordat artikelen verschijnen.',
          'Shopify-achtig beheer',
          'Bekijk verzoeken, artikelen en beslissingen in het beheer.',
          'E-mailsjablooneditor',
          'Bereid bevestigings-, goedkeurings- en afwijzingsmails voor.',
          'Ervaring in 23 talen',
          'Vertaal winkel, formulieren, backend en demo met één selector.',
          'App-abonnementen',
          'Kies het abonnement voor uw winkel.',
          'Start eenvoudig en upgrade voor automatisering.',
          'Gratis',
          'Altijd',
          'Voor winkels die starten met elektronische herroepingen.',
          'Vaste herroepingsknop',
          'Lade- en paginaformulier',
          'Bestel- en e-mailcontrole',
          'Dashboard voor verzoeken',
          'Meertalige klantervaring',
          'Gratis starten',
          'Aanbevolen',
          'Pro',
          ' / maand',
          'Voor geavanceerde workflows en automatisering.',
          'Alles uit Gratis',
          'Goedkeurings- en afwijzingsmails',
          'Automatisch Shopify-retourverzoek',
          'Geavanceerde regels',
          'Aangepaste CSS en juridische instellingen',
          'Gratis proefperiode',
          'FAQ',
          'Veelgestelde vragen van merchants.',
          'Moet de klant inloggen?',
          'Nee, naam, e-mail en bestelnummer zijn voldoende.',
          'Hoe worden bestellingen gecontroleerd?',
          'De app vergelijkt bestelnummer en e-mail voordat artikelen worden getoond.',
          'Kan ik een lade en aparte pagina gebruiken?',
          'Ja, beide ervaringen zijn opgenomen.',
          'Welke talen worden ondersteund?',
          'De demo ondersteunt 23 Europese talen.',
          'Kan de knop bij mijn thema passen?',
          'Ja, tekst, uitlijning, ruimte, kleuren, lettertype en rand zijn aanpasbaar.',
          'Een interactieve preview van het herroepingsproces.',
          'Functies',
          'Abonnementen',
          'FAQ',
          'Live demo',
          '© 2026 Slash Themes. Alle rechten voorbehouden.',
          'Support: support@slashthemes.com',
        ],
        fr: [
          'Fonctionnalités',
          'Tout pour un parcours de rétractation clair.',
          'Offrez une expérience simple et gardez chaque demande organisée.',
          'Bouton de rétractation fixe',
          'Gardez l’action visible et personnalisez-la en direct.',
          'Formulaire tiroir et page',
          'Proposez un tiroir latéral ou une page dédiée.',
          'Vérification de commande en direct',
          'Vérifiez la commande et l’e-mail avant d’afficher les articles.',
          'Gestion inspirée de Shopify',
          'Examinez les demandes et gérez les décisions dans l’application.',
          'Éditeur de modèles d’e-mail',
          'Préparez les e-mails de confirmation, approbation et refus.',
          'Expérience en 23 langues',
          'Traduisez la boutique, les formulaires et le backend depuis un sélecteur.',
          'Forfaits',
          'Choisissez le forfait adapté à votre boutique.',
          'Commencez avec l’essentiel puis ajoutez l’automatisation.',
          'Gratuit',
          'Pour toujours',
          'Pour les boutiques qui débutent avec la rétractation électronique.',
          'Bouton fixe',
          'Formulaire tiroir et page',
          'Vérification commande/e-mail',
          'Tableau des demandes',
          'Expérience multilingue',
          'Commencer gratuitement',
          'Recommandé',
          'Pro',
          ' / mois',
          'Pour les workflows et automatisations avancés.',
          'Tout le forfait Gratuit',
          'E-mails d’approbation et de refus',
          'Demande de retour Shopify automatique',
          'Règles avancées',
          'CSS et paramètres juridiques',
          'Essai gratuit',
          'FAQ',
          'Questions fréquentes des marchands.',
          'Le client doit-il se connecter ?',
          'Non. Le nom, l’e-mail et le numéro de commande suffisent.',
          'Comment la commande est-elle vérifiée ?',
          'L’application compare le numéro de commande et l’e-mail.',
          'Puis-je utiliser un tiroir et une page dédiée ?',
          'Oui, les deux expériences sont incluses.',
          'Quelles langues sont disponibles ?',
          'La démo prend en charge 23 langues européennes.',
          'Le bouton peut-il correspondre à mon thème ?',
          'Oui, son texte, alignement, couleurs, taille et bordure sont réglables.',
          'Une prévisualisation complète du parcours de rétractation.',
          'Fonctionnalités',
          'Forfaits',
          'FAQ',
          'Démo en direct',
          '© 2026 Slash Themes. Tous droits réservés.',
          'Support : support@slashthemes.com',
        ],
        el: [
          'Χαρακτηριστικά εφαρμογής',
          'Όλα για μια σαφή διαδικασία υπαναχώρησης.',
          'Απλή εμπειρία για πελάτες και οργανωμένα αιτήματα.',
          'Σταθερό κουμπί υπαναχώρησης',
          'Διατηρήστε την ενέργεια ορατή και προσαρμόστε την ζωντανά.',
          'Φόρμα συρταριού και σελίδας',
          'Χρησιμοποιήστε πλαϊνό συρτάρι ή ξεχωριστή σελίδα.',
          'Άμεση επαλήθευση παραγγελίας',
          'Έλεγχος παραγγελίας και email πριν εμφανιστούν τα προϊόντα.',
          'Διαχείριση τύπου Shopify',
          'Ελέγξτε αιτήματα και αποφάσεις στο backend.',
          'Επεξεργαστής email',
          'Προετοιμάστε email επιβεβαίωσης, έγκρισης και απόρριψης.',
          'Εμπειρία σε 23 γλώσσες',
          'Μεταφράστε βιτρίνα, φόρμες και backend.',
          'Πλάνα εφαρμογής',
          'Επιλέξτε το κατάλληλο πλάνο.',
          'Ξεκινήστε με τα βασικά και αναβαθμίστε για αυτοματοποίηση.',
          'Δωρεάν',
          'Για πάντα',
          'Για καταστήματα που ξεκινούν ηλεκτρονικές υπαναχωρήσεις.',
          'Σταθερό κουμπί',
          'Φόρμα συρταριού και σελίδας',
          'Έλεγχος παραγγελίας και email',
          'Πίνακας αιτημάτων',
          'Πολυγλωσσική εμπειρία',
          'Ξεκινήστε δωρεάν',
          'Προτεινόμενο',
          'Pro',
          ' / μήνα',
          'Για προηγμένες ροές και αυτοματοποίηση.',
          'Όλα του δωρεάν πλάνου',
          'Email έγκρισης και απόρριψης',
          'Αυτόματο αίτημα επιστροφής Shopify',
          'Προηγμένοι κανόνες',
          'Προσαρμοσμένο CSS και νομικές ρυθμίσεις',
          'Δωρεάν δοκιμή',
          'Συχνές ερωτήσεις',
          'Συνήθεις ερωτήσεις εμπόρων.',
          'Χρειάζεται σύνδεση ο πελάτης;',
          'Όχι. Αρκούν όνομα, email και αριθμός παραγγελίας.',
          'Πώς επαληθεύονται τα στοιχεία;',
          'Η εφαρμογή ελέγχει αριθμό παραγγελίας και email.',
          'Μπορώ να χρησιμοποιήσω συρτάρι και σελίδα;',
          'Ναι, περιλαμβάνονται και τα δύο.',
          'Ποιες γλώσσες υποστηρίζονται;',
          'Υποστηρίζονται 23 ευρωπαϊκές γλώσσες.',
          'Μπορεί το κουμπί να ταιριάξει στο θέμα μου;',
          'Ναι, προσαρμόζονται κείμενο, χρώματα, μέγεθος και περίγραμμα.',
          'Πλήρης διαδραστική προεπισκόπηση της διαδικασίας υπαναχώρησης.',
          'Χαρακτηριστικά',
          'Πλάνα',
          'FAQ',
          'Ζωντανή επίδειξη',
          '© 2026 Slash Themes. Με επιφύλαξη δικαιωμάτων.',
          'Υποστήριξη: support@slashthemes.com',
        ],
        fi: [
          'Sovelluksen ominaisuudet',
          'Kaikki selkeään peruuttamisprosessiin.',
          'Tarjoa helppo asiakaskokemus ja järjestä pyynnöt.',
          'Kiinteä peruutuspainike',
          'Pidä toiminto näkyvissä ja muokkaa sitä livenä.',
          'Sivupaneeli- ja sivulomake',
          'Käytä sivupaneelia tai erillistä sivua.',
          'Tilauksen reaaliaikainen tarkistus',
          'Tarkista tilaus ja sähköposti ennen tuotteita.',
          'Shopify-tyylinen hallinta',
          'Tarkista pyynnöt ja päätökset hallinnassa.',
          'Sähköpostimallien editori',
          'Valmistele vahvistus-, hyväksyntä- ja hylkäysviestit.',
          'Kokemus 23 kielellä',
          'Käännä kauppa, lomakkeet ja hallinta.',
          'Sovelluksen paketit',
          'Valitse kaupallesi sopiva paketti.',
          'Aloita perustoiminnoilla ja päivitä automaatioon.',
          'Ilmainen',
          'Aina',
          'Sähköisiä peruutuksia aloittaville kaupoille.',
          'Kiinteä painike',
          'Sivupaneeli ja sivu',
          'Tilauksen ja sähköpostin tarkistus',
          'Pyyntöjen hallinta',
          'Monikielinen kokemus',
          'Aloita ilmaiseksi',
          'Suositeltu',
          'Pro',
          ' / kuukausi',
          'Edistyneisiin työnkulkuihin.',
          'Kaikki ilmaisesta',
          'Hyväksyntä- ja hylkäysviestit',
          'Automaattinen Shopify-palautus',
          'Edistyneet säännöt',
          'Mukautettu CSS ja lakiasetukset',
          'Aloita kokeilu',
          'UKK',
          'Kauppiaiden yleisiä kysymyksiä.',
          'Tarvitseeko asiakkaan kirjautua?',
          'Ei. Nimi, sähköposti ja tilausnumero riittävät.',
          'Miten tilaus tarkistetaan?',
          'Sovellus vertaa tilausnumeroa ja sähköpostia.',
          'Voinko käyttää paneelia ja sivua?',
          'Kyllä, molemmat ovat mukana.',
          'Mitä kieliä tuetaan?',
          'Demo tukee 23 eurooppalaista kieltä.',
          'Voiko painike sopia teemaani?',
          'Kyllä, tekstiä, värejä, kokoa ja reunaa voi muuttaa.',
          'Täydellinen interaktiivinen peruutusprosessin esikatselu.',
          'Ominaisuudet',
          'Paketit',
          'UKK',
          'Live-demo',
          '© 2026 Slash Themes. Kaikki oikeudet pidätetään.',
          'Tuki: support@slashthemes.com',
        ],
        sv: [
          'Appfunktioner',
          'Allt för en tydlig ångerprocess.',
          'Ge kunder en enkel upplevelse och håll begäranden organiserade.',
          'Fast ångerknapp',
          'Håll åtgärden synlig och anpassa den live.',
          'Låd- och sidformulär',
          'Använd en sidolåda eller en separat sida.',
          'Direkt orderverifiering',
          'Kontrollera order och e-post innan artiklar visas.',
          'Shopify-liknande hantering',
          'Granska begäranden och beslut i backend.',
          'E-postmallsredigerare',
          'Förbered bekräftelse-, godkännande- och avslagsmail.',
          'Upplevelse på 23 språk',
          'Översätt butik, formulär och backend.',
          'Appplaner',
          'Välj planen som passar din butik.',
          'Börja med grunderna och uppgradera för automation.',
          'Gratis',
          'För alltid',
          'För butiker som börjar med elektronisk ångerrätt.',
          'Fast knapp',
          'Låd- och sidformulär',
          'Order- och e-postkontroll',
          'Begärandepanel',
          'Flerspråkig upplevelse',
          'Starta gratis',
          'Rekommenderad',
          'Pro',
          ' / månad',
          'För avancerade flöden och automation.',
          'Allt i Gratis',
          'Godkännande- och avslagsmail',
          'Automatisk Shopify-retur',
          'Avancerade regler',
          'Anpassad CSS och juridik',
          'Starta provperiod',
          'FAQ',
          'Vanliga frågor från handlare.',
          'Måste kunden logga in?',
          'Nej. Namn, e-post och ordernummer räcker.',
          'Hur verifieras ordern?',
          'Appen jämför ordernummer och e-post.',
          'Kan jag använda låda och sida?',
          'Ja, båda finns med.',
          'Vilka språk stöds?',
          'Demon stöder 23 europeiska språk.',
          'Kan knappen matcha mitt tema?',
          'Ja, text, färger, storlek och kant kan ändras.',
          'En komplett interaktiv förhandsvisning.',
          'Funktioner',
          'Planer',
          'FAQ',
          'Live-demo',
          '© 2026 Slash Themes. Alla rättigheter förbehållna.',
          'Support: support@slashthemes.com',
        ],
        hu: [
          'Alkalmazásfunkciók',
          'Minden a világos elállási folyamathoz.',
          'Egyszerű ügyfélélmény és rendezett kérelmek.',
          'Rögzített elállási gomb',
          'Tartsa láthatóan és szabja személyre élőben.',
          'Oldalsó panel és oldal',
          'Használjon panelt vagy külön oldalt.',
          'Élő rendelésellenőrzés',
          'Rendelés és e-mail ellenőrzése.',
          'Shopify-stílusú kezelés',
          'Kérelmek és döntések kezelése.',
          'E-mail sablonszerkesztő',
          'Megerősítő, jóváhagyó és elutasító e-mailek.',
          '23 nyelvű élmény',
          'Fordítsa le a boltot, űrlapokat és backendet.',
          'Csomagok',
          'Válassza ki a megfelelő csomagot.',
          'Kezdje az alapokkal és váltson automatizálásra.',
          'Ingyenes',
          'Örökre',
          'Elektronikus elállást indító boltoknak.',
          'Rögzített gomb',
          'Panel és oldal',
          'Rendelés- és e-mail-ellenőrzés',
          'Kérelemkezelés',
          'Többnyelvű élmény',
          'Kezdés ingyen',
          'Ajánlott',
          'Pro',
          ' / hónap',
          'Haladó munkafolyamatokhoz.',
          'Minden az ingyenesben',
          'Jóváhagyó és elutasító e-mailek',
          'Automatikus Shopify-visszaküldés',
          'Haladó szabályok',
          'Egyedi CSS és jogi beállítások',
          'Ingyenes próba',
          'GYIK',
          'Gyakori kereskedői kérdések.',
          'Kell bejelentkezés?',
          'Nem. Név, e-mail és rendelési szám elég.',
          'Hogyan történik az ellenőrzés?',
          'Az app összeveti a rendelési számot és az e-mailt.',
          'Használható panel és oldal?',
          'Igen, mindkettő elérhető.',
          'Milyen nyelvek támogatottak?',
          'A demo 23 európai nyelvet támogat.',
          'Illeszkedhet a gomb a témához?',
          'Igen, a szöveg, színek, méret és keret állítható.',
          'Teljes interaktív elállási előnézet.',
          'Funkciók',
          'Csomagok',
          'GYIK',
          'Élő demo',
          '© 2026 Slash Themes. Minden jog fenntartva.',
          'Támogatás: support@slashthemes.com',
        ],
        ga: [
          'Gnéithe',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Pleananna',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'Ceisteanna Coitianta',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Gnéithe',
          'Pleananna',
          'Ceisteanna Coitianta',
          'Taispeántas beo',
        ],
        it: [
          'Funzionalità',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Piani',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funzionalità',
          'Piani',
          'FAQ',
          'Demo live',
        ],
        pl: [
          'Funkcje',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Plany',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funkcje',
          'Plany',
          'FAQ',
          'Demo na żywo',
        ],
        ro: [
          'Funcții',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Planuri',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funcții',
          'Planuri',
          'FAQ',
          'Demo live',
        ],
        pt: [
          'Funcionalidades',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Planos',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funcionalidades',
          'Planos',
          'FAQ',
          'Demo ao vivo',
        ],
        es: [
          'Funciones',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Planes',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funciones',
          'Planes',
          'FAQ',
          'Demo en vivo',
        ],
        cs: [
          'Funkce',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Plány',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funkce',
          'Plány',
          'FAQ',
          'Živá ukázka',
        ],
        da: [
          'Funktioner',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Planer',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funktioner',
          'Planer',
          'FAQ',
          'Live-demo',
        ],
        et: [
          'Funktsioonid',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Paketid',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'KKK',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funktsioonid',
          'Paketid',
          'KKK',
          'Reaalajas demo',
        ],
        lv: [
          'Funkcijas',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Plāni',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'BUJ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funkcijas',
          'Plāni',
          'BUJ',
          'Tiešraides demonstrācija',
        ],
        lt: [
          'Funkcijos',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Planai',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'DUK',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funkcijos',
          'Planai',
          'DUK',
          'Tiesioginė demonstracija',
        ],
        mt: [
          'Karatteristiċi',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Pjanijiet',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Karatteristiċi',
          'Pjanijiet',
          'FAQ',
          'Demo diretta',
        ],
        sk: [
          'Funkcie',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Plány',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funkcie',
          'Plány',
          'FAQ',
          'Živá ukážka',
        ],
        sl: [
          'Funkcije',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Paketi',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Funkcije',
          'Paketi',
          'FAQ',
          'Predstavitev v živo',
        ],
        hr: [
          'Značajke',
          'Everything needed for a clear withdrawal workflow.',
          'Give customers a simple withdrawal experience and keep every merchant request organized.',
          'Sticky withdrawal button',
          'Keep the withdrawal action visible and customize its appearance directly in the demo.',
          'Drawer and page forms',
          'Offer a right-side drawer or a dedicated withdrawal page for customer requests.',
          'Live order verification',
          'Validate the order ID and email instantly before showing eligible line items.',
          'Shopify-style management',
          'Review requests, inspect affected items and manage decisions from the app backend.',
          'Email template editor',
          'Prepare confirmation, approval and rejection emails in supported languages.',
          '23-language experience',
          'Translate the storefront, forms, backend controls and demo content from one selector.',
          'Planovi',
          'Choose the plan that fits your store.',
          'Start with the essential withdrawal flow and upgrade when you need advanced automation.',
          'Free',
          'Forever',
          'For stores starting with electronic withdrawals.',
          'Sticky withdrawal button',
          'Drawer and dedicated page form',
          'Order and email verification',
          'Request management dashboard',
          'Multilingual customer experience',
          'Start free',
          'Recommended',
          'Pro',
          ' / month',
          'For merchants that need advanced workflows and automation.',
          'Everything included in Free',
          'Approval and rejection email templates',
          'Automatic Shopify return request',
          'Advanced eligibility and automation rules',
          'Custom CSS and legal settings',
          'Start free trial',
          'FAQ',
          'FAQ',
          'Does the customer need to log in?',
          'No. Customers can submit a withdrawal using their name, email and order ID without creating an account.',
          'How are order details verified?',
          'The app checks the order ID and customer email. Eligible items are shown only after both details match.',
          'Can I use a drawer and a dedicated page?',
          'Yes. The demo includes both experiences so merchants can review the format that best fits their storefront.',
          'Which languages are supported?',
          'The demo supports 23 European languages across the storefront, form controls and backend preview.',
          'Can the sticky button match my theme?',
          'Yes. You can adjust its text, alignment, padding, colors, font size, border width and radius in the live preview.',
          'A complete interactive preview of the customer withdrawal experience and merchant workflow.',
          'Features',
          'Plans',
          'Značajke',
          'Planovi',
          'FAQ',
          'Demo uživo',
        ],
      };
      function siteText(key) {
        const index = SITE_SECTION_KEYS.indexOf(key);
        const pack = SITE_SECTION_I18N[state.language] || SITE_SECTION_I18N.en;
        return index >= 0 ? pack[index] || SITE_SECTION_I18N.en[index] || key : key;
      }
      function applySiteSectionTranslations() {
        document.querySelectorAll('[data-site-i18n]').forEach((element) => {
          const key = element.dataset.siteI18n;
          element.textContent = siteText(key);
        });
      }
      function bindFaqAccordion() {
        document.querySelectorAll('.faq-toggle').forEach((button) => {
          if (button.dataset.faqBound === '1') return;
          button.dataset.faqBound = '1';
          button.addEventListener('click', () => {
            const item = button.closest('.faq-item');
            const answer = item?.querySelector('.faq-answer');
            const icon = item?.querySelector('.faq-icon');
            if (!answer) return;
            const opening = answer.classList.contains('hidden');
            document.querySelectorAll('.faq-answer').forEach((node) => node.classList.add('hidden'));
            document.querySelectorAll('.faq-icon').forEach((node) => (node.textContent = '+'));
            if (opening) {
              answer.classList.remove('hidden');
              if (icon) icon.textContent = '−';
            }
          });
        });
      }

      function init() {
        const params = new URLSearchParams(window.location.search);
        const urlLanguage = (params.get('lang') || '').toLowerCase();
        if (translations[urlLanguage]) state.language = urlLanguage;
        else state.language = 'en';

        state.settings.buttonText = tr('button');

        $('#languageSelect').innerHTML = Object.entries(translations)
          .map(([k, v]) => `<option value="${k}">${v.name}</option>`)
          .join('');
        $('#languageSelect').value = state.language;
        $('#languageSelect').onchange = (e) => {
          state.language = e.target.value;
          state.settings.buttonText = tr('button');

          const nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('lang', state.language);
          window.history.replaceState({}, '', nextUrl);

          applyGlobalTranslations();
          render();
        };
        $('#formModeSelect').onchange = (e) => {
          state.mode = e.target.value;
          resetCustomerFlow(false);
          render();
        };
        $$('.main-tab').forEach((button) => {
          button.onclick = () => {
            const target = button.dataset.view;

            if (target === 'storefront') {
              state.view = 'storefront';
              state.adminPage = 'management';
            } else if (target === 'requests') {
              state.view = 'requests';
              state.adminPage = 'management';
            } else if (target === 'settings') {
              state.view = 'settings';
              state.adminPage = 'settings';
            }

            render();
          };
        });
        applyGlobalTranslations();
        render();
        bindFaqAccordion();
      }

      function applyGlobalTranslations() {
        document.documentElement.lang = state.language;
        const map = {
          headerSubtitle: 'interactiveDemo',
          openDemoLink: 'openDemo',
          heroBadge: 'frontendBackend',
          heroTitleOne: 'heroOne',
          heroTitleTwo: 'heroTwo',
          heroDescription: 'heroDescription',
          validDemoTitle: 'validDemo',
          demoOrderLabel: 'orderLabel',
          demoEmailLabel: 'emailLabel',
          storefrontTabLabel: 'storefront',
          requestsTabLabel: 'requestsBackend',
          settingsTabLabel: 'appSettings',
        };
        Object.entries(map).forEach(([id, key]) => {
          const el = $('#' + id);
          if (el) el.textContent = ui(key);
        });
        $('#popupModeOption').textContent = ui('popupForm');
        $('#pageModeOption').textContent = ui('dedicatedPage');
        applySiteSectionTranslations();
      }

      function render() {
        applyGlobalTranslations();
        updateTabs();
        $('#languageSelect').disabled = false;
        $('#formModeSelect').disabled = state.view !== 'storefront';
        $('#browserTitle').textContent =
          state.view === 'storefront'
            ? ui('storefrontPreview')
            : state.view === 'requests'
            ? ui('backendPreview')
            : ui('settingsPreview');
        let nextMarkup;
        if (state.view === 'storefront') nextMarkup = storefrontView();
        else if (state.view === 'requests') nextMarkup = requestsView();
        else nextMarkup = settingsView();
        $('#appPreview').innerHTML = nextMarkup;
        bindView();
        if (state.view === 'storefront' && state.mode === 'popup' && state.popup) {
          requestAnimationFrame(openDrawer);
        }
      }

      function updateTabs() {
        $$('.main-tab').forEach((b) => {
          const active = b.dataset.view === state.view;
          b.className = active
            ? 'main-tab rounded-full bg-navy px-5 py-3 text-sm font-black text-white'
            : 'main-tab rounded-full border border-navy/10 bg-white px-5 py-3 text-sm font-black text-slateink';
        });
        $('#languageSelect').value = state.language;
        $('#formModeSelect').value = state.mode;
      }

      const BUTTON_CONTROL_KEYS = [
        'title',
        'buttonText',
        'alignment',
        'left',
        'center',
        'right',
        'verticalPadding',
        'horizontalPadding',
        'backgroundColor',
        'textColor',
        'fontSize',
        'borderColor',
        'borderWidth',
        'borderRadius',
        'px',
      ];
      const BUTTON_CONTROL_I18N = {
        en: [
          'Sticky button settings',
          'Button Text',
          'Button Alignment',
          'Left',
          'Center',
          'Right',
          'Vertical Padding',
          'Horizontal Padding',
          'Button Background Color',
          'Button Text Color',
          'Font size',
          'Button border',
          'Button border width',
          'Button Border Radius',
          'px',
        ],
        de: [
          'Einstellungen für festen Button',
          'Button-Text',
          'Button-Ausrichtung',
          'Links',
          'Mitte',
          'Rechts',
          'Vertikaler Abstand',
          'Horizontaler Abstand',
          'Button-Hintergrundfarbe',
          'Button-Textfarbe',
          'Schriftgröße',
          'Button-Rahmen',
          'Rahmenbreite',
          'Rahmenradius',
          'px',
        ],
        nl: [
          'Instellingen vaste knop',
          'Knoptekst',
          'Knopuitlijning',
          'Links',
          'Midden',
          'Rechts',
          'Verticale opvulling',
          'Horizontale opvulling',
          'Achtergrondkleur knop',
          'Tekstkleur knop',
          'Lettergrootte',
          'Knoprand',
          'Randbreedte',
          'Randradius',
          'px',
        ],
        fr: [
          'Paramètres du bouton fixe',
          'Texte du bouton',
          'Alignement du bouton',
          'Gauche',
          'Centre',
          'Droite',
          'Espacement vertical',
          'Espacement horizontal',
          'Couleur de fond',
          'Couleur du texte',
          'Taille de police',
          'Bordure du bouton',
          'Largeur de bordure',
          'Rayon de bordure',
          'px',
        ],
        el: [
          'Ρυθμίσεις σταθερού κουμπιού',
          'Κείμενο κουμπιού',
          'Στοίχιση κουμπιού',
          'Αριστερά',
          'Κέντρο',
          'Δεξιά',
          'Κάθετη απόσταση',
          'Οριζόντια απόσταση',
          'Χρώμα φόντου',
          'Χρώμα κειμένου',
          'Μέγεθος γραμματοσειράς',
          'Περίγραμμα κουμπιού',
          'Πλάτος περιγράμματος',
          'Ακτίνα περιγράμματος',
          'px',
        ],
        fi: [
          'Kiinteän painikkeen asetukset',
          'Painikkeen teksti',
          'Painikkeen tasaus',
          'Vasen',
          'Keskellä',
          'Oikea',
          'Pystytäyttö',
          'Vaakatäyttö',
          'Taustaväri',
          'Tekstin väri',
          'Fonttikoko',
          'Painikkeen reunus',
          'Reunuksen leveys',
          'Reunuksen säde',
          'px',
        ],
        sv: [
          'Inställningar för fast knapp',
          'Knapptext',
          'Knappjustering',
          'Vänster',
          'Centrerad',
          'Höger',
          'Vertikal utfyllnad',
          'Horisontell utfyllnad',
          'Bakgrundsfärg',
          'Textfärg',
          'Teckenstorlek',
          'Knappram',
          'Rambredd',
          'Ramradie',
          'px',
        ],
        hu: [
          'Rögzített gomb beállításai',
          'Gomb szövege',
          'Gomb igazítása',
          'Bal',
          'Közép',
          'Jobb',
          'Függőleges térköz',
          'Vízszintes térköz',
          'Háttérszín',
          'Szövegszín',
          'Betűméret',
          'Gomb kerete',
          'Keretvastagság',
          'Keret sugara',
          'px',
        ],
        ga: [
          'Socruithe an chnaipe ghreamaitheach',
          'Téacs an chnaipe',
          'Ailíniú an chnaipe',
          'Clé',
          'Lár',
          'Deas',
          'Stuáil ingearach',
          'Stuáil chothrománach',
          'Dath cúlra',
          'Dath téacs',
          'Clómhéid',
          'Teorainn an chnaipe',
          'Leithead teorann',
          'Ga teorann',
          'px',
        ],
        it: [
          'Impostazioni pulsante fisso',
          'Testo pulsante',
          'Allineamento pulsante',
          'Sinistra',
          'Centro',
          'Destra',
          'Spaziatura verticale',
          'Spaziatura orizzontale',
          'Colore sfondo',
          'Colore testo',
          'Dimensione carattere',
          'Bordo pulsante',
          'Larghezza bordo',
          'Raggio bordo',
          'px',
        ],
        pl: [
          'Ustawienia przycisku stałego',
          'Tekst przycisku',
          'Wyrównanie przycisku',
          'Lewo',
          'Środek',
          'Prawo',
          'Odstęp pionowy',
          'Odstęp poziomy',
          'Kolor tła',
          'Kolor tekstu',
          'Rozmiar czcionki',
          'Obramowanie przycisku',
          'Szerokość obramowania',
          'Promień obramowania',
          'px',
        ],
        ro: [
          'Setări buton fix',
          'Text buton',
          'Aliniere buton',
          'Stânga',
          'Centru',
          'Dreapta',
          'Spațiere verticală',
          'Spațiere orizontală',
          'Culoare fundal',
          'Culoare text',
          'Dimensiune font',
          'Chenar buton',
          'Lățime chenar',
          'Rază chenar',
          'px',
        ],
        pt: [
          'Definições do botão fixo',
          'Texto do botão',
          'Alinhamento do botão',
          'Esquerda',
          'Centro',
          'Direita',
          'Espaçamento vertical',
          'Espaçamento horizontal',
          'Cor de fundo',
          'Cor do texto',
          'Tamanho da fonte',
          'Contorno do botão',
          'Largura do contorno',
          'Raio do contorno',
          'px',
        ],
        es: [
          'Configuración del botón fijo',
          'Texto del botón',
          'Alineación del botón',
          'Izquierda',
          'Centro',
          'Derecha',
          'Relleno vertical',
          'Relleno horizontal',
          'Color de fondo',
          'Color del texto',
          'Tamaño de fuente',
          'Borde del botón',
          'Ancho del borde',
          'Radio del borde',
          'px',
        ],
        cs: [
          'Nastavení pevného tlačítka',
          'Text tlačítka',
          'Zarovnání tlačítka',
          'Vlevo',
          'Na střed',
          'Vpravo',
          'Svislé odsazení',
          'Vodorovné odsazení',
          'Barva pozadí',
          'Barva textu',
          'Velikost písma',
          'Ohraničení tlačítka',
          'Šířka ohraničení',
          'Poloměr ohraničení',
          'px',
        ],
        da: [
          'Indstillinger for fast knap',
          'Knaptekst',
          'Knapjustering',
          'Venstre',
          'Centreret',
          'Højre',
          'Lodret polstring',
          'Vandret polstring',
          'Baggrundsfarve',
          'Tekstfarve',
          'Skriftstørrelse',
          'Knapkant',
          'Kantbredde',
          'Kantradius',
          'px',
        ],
        et: [
          'Fikseeritud nupu seaded',
          'Nupu tekst',
          'Nupu joondus',
          'Vasak',
          'Keskel',
          'Parem',
          'Vertikaalne täidis',
          'Horisontaalne täidis',
          'Taustavärv',
          'Teksti värv',
          'Fondi suurus',
          'Nupu ääris',
          'Äärise laius',
          'Äärise raadius',
          'px',
        ],
        lv: [
          'Fiksētās pogas iestatījumi',
          'Pogas teksts',
          'Pogas līdzinājums',
          'Pa kreisi',
          'Centrā',
          'Pa labi',
          'Vertikālā atkāpe',
          'Horizontālā atkāpe',
          'Fona krāsa',
          'Teksta krāsa',
          'Fonta izmērs',
          'Pogas apmale',
          'Apmales platums',
          'Apmales rādiuss',
          'px',
        ],
        lt: [
          'Fiksuoto mygtuko nustatymai',
          'Mygtuko tekstas',
          'Mygtuko lygiavimas',
          'Kairė',
          'Centras',
          'Dešinė',
          'Vertikalus tarpas',
          'Horizontalus tarpas',
          'Fono spalva',
          'Teksto spalva',
          'Šrifto dydis',
          'Mygtuko rėmelis',
          'Rėmelio plotis',
          'Rėmelio spindulys',
          'px',
        ],
        mt: [
          'Settings tal-buttuna fissa',
          'Test tal-buttuna',
          'Allinjament tal-buttuna',
          'Xellug',
          'Ċentru',
          'Lemin',
          'Spazjar vertikali',
          'Spazjar orizzontali',
          'Kulur tal-isfond',
          'Kulur tat-test',
          'Daqs tat-tipa',
          'Bordura tal-buttuna',
          'Wisa’ tal-bordura',
          'Raġġ tal-bordura',
          'px',
        ],
        sk: [
          'Nastavenia pevného tlačidla',
          'Text tlačidla',
          'Zarovnanie tlačidla',
          'Vľavo',
          'Na stred',
          'Vpravo',
          'Zvislé odsadenie',
          'Vodorovné odsadenie',
          'Farba pozadia',
          'Farba textu',
          'Veľkosť písma',
          'Okraj tlačidla',
          'Šírka okraja',
          'Polomer okraja',
          'px',
        ],
        sl: [
          'Nastavitve fiksnega gumba',
          'Besedilo gumba',
          'Poravnava gumba',
          'Levo',
          'Sredina',
          'Desno',
          'Navpični odmik',
          'Vodoravni odmik',
          'Barva ozadja',
          'Barva besedila',
          'Velikost pisave',
          'Obroba gumba',
          'Širina obrobe',
          'Polmer obrobe',
          'px',
        ],
        hr: [
          'Postavke fiksnog gumba',
          'Tekst gumba',
          'Poravnanje gumba',
          'Lijevo',
          'Sredina',
          'Desno',
          'Okomiti razmak',
          'Vodoravni razmak',
          'Boja pozadine',
          'Boja teksta',
          'Veličina fonta',
          'Obrub gumba',
          'Širina obruba',
          'Polumjer obruba',
          'px',
        ],
      };
      function bc(key) {
        const index = BUTTON_CONTROL_KEYS.indexOf(key);
        const pack = BUTTON_CONTROL_I18N[state.language] || BUTTON_CONTROL_I18N.en;
        return index >= 0 ? pack[index] || BUTTON_CONTROL_I18N.en[index] || key : key;
      }

      function storefrontView() {
        if (state.mode === 'page') {
          return `<div class="checker min-h-[720px] p-3 sm:p-5">
      <div class="mx-auto h-[680px] max-w-[980px] overflow-hidden rounded-[24px] border border-navy/10 bg-white shadow-float">
        ${formPage()}
      </div>
    </div>`;
        }

        return `<div class="checker min-h-[720px] p-3 sm:p-5">
    <div class="mx-auto grid h-[680px] max-w-[1180px] overflow-hidden rounded-[24px] border border-navy/10 bg-white shadow-float lg:grid-cols-[300px_1fr]">
      ${stickyButtonControlPanel()}

      <div class="relative min-w-0 overflow-hidden bg-white">
        <header class="flex h-[64px] items-center justify-between border-b border-navy/10 px-5">
          <strong class="text-lg tracking-[-.03em]">ATELIER NORTH</strong>
          <nav class="hidden gap-6 text-[11px] font-black uppercase tracking-[.13em] text-slateink/55 sm:flex">
            <span>${ui('shop')}</span><span>${ui('stories')}</span><span>${ui('about')}</span><span>${ui('bag')}</span>
          </nav><span class="sm:hidden">☰</span>
        </header>

        ${shopHome()}
        ${state.settings.popupEnabled ? stickyButton() : ''}
        ${state.settings.popupEnabled ? popupForm() : ''}
      </div>
    </div>
  </div>`;
      }

      function stickyButtonControlPanel() {
        const s = state.settings;
        return `<aside class="control-scroll h-full overflow-y-auto border-r border-navy/10 bg-[#f7f7f7] p-4">
    <p class="text-[11px] font-black uppercase tracking-[.16em] text-slateink/45">${bc('title')}</p>

    <label class="mt-4 block text-xs font-medium">${bc('buttonText')}</label>
    <input id="stickyButtonText" value="${esc(
      s.buttonText
    )}" class="mt-1.5 w-full rounded-lg border border-[#9f9f9f] bg-white px-3 py-2 text-sm outline-none focus:border-navy">

    <div class="mt-4 text-xs font-medium">${bc('alignment')}</div>
    <div class="mt-2 grid grid-cols-3 overflow-hidden rounded-lg border border-[#d7d7d7] bg-white">
      ${['left', 'center', 'right']
        .map(
          (position) =>
            `<button class="sticky-align px-2 py-2 text-xs ${
              s.position === position ? 'bg-white font-semibold shadow-sm' : 'bg-[#f4f4f4]'
            }" data-position="${position}">${bc(position)}</button>`
        )
        .join('')}
    </div>

    ${rangeControl('stickyVerticalPadding', bc('verticalPadding'), s.verticalPadding, 6, 24)}
    ${rangeControl('stickyHorizontalPadding', bc('horizontalPadding'), s.horizontalPadding, 12, 48)}
    ${colorControl('stickyBackgroundColor', bc('backgroundColor'), s.color)}
    ${colorControl('stickyTextColor', bc('textColor'), s.textColor)}
    ${rangeControl('stickyFontSize', bc('fontSize'), s.fontSize, 11, 22)}
    ${colorControl('stickyBorderColor', bc('borderColor'), s.borderColor)}
    ${rangeControl('stickyBorderWidth', bc('borderWidth'), s.borderWidth, 0, 6)}
    ${rangeControl('stickyBorderRadius', bc('borderRadius'), s.radius, 0, 40)}
  </aside>`;
      }

      function rangeControl(id, label, value, min, max) {
        return `<label class="mt-4 block">
    <span class="text-xs font-medium">${label}</span>
    <div class="mt-2 grid grid-cols-[1fr_68px] items-center gap-2">
      <input id="${id}" type="range" min="${min}" max="${max}" value="${value}" class="range-input w-full">
      <span class="rounded-lg border border-[#9f9f9f] bg-white px-2 py-2 text-center text-xs"><strong id="${id}Value">${value}</strong> ${bc(
          'px'
        )}</span>
    </div>
  </label>`;
      }

      function colorControl(id, label, value) {
        return `<label class="mt-4 block">
    <span class="text-xs font-medium">${label}</span>
    <div class="mt-2 flex items-center gap-2 rounded-lg border border-[#9f9f9f] bg-white px-2 py-2">
      <input id="${id}" type="color" value="${value}" class="h-6 w-7 cursor-pointer rounded border-0 bg-transparent p-0">
      <input id="${id}Text" value="${value.toUpperCase()}" class="min-w-0 flex-1 bg-transparent text-xs uppercase outline-none">
    </div>
  </label>`;
      }

      function shopHome() {
        return `<main>
    <section class="grid h-[300px] items-center bg-[#E8DDD0] px-7 py-8 sm:px-12">
      <div class="max-w-xl">
        <p class="text-xs font-black uppercase tracking-[.2em] text-coral">${ui('autumnEssentials')}</p>
        <h2 class="mt-5 text-4xl font-black leading-[.95] tracking-[-.05em] sm:text-5xl">${ui('storeHero')}</h2>
        <button class="mt-5 rounded-full bg-navy px-6 py-3 text-sm font-black text-white">${ui(
          'exploreCollection'
        )}</button>
      </div>
    </section>
    <section class="grid grid-cols-4 gap-3 p-4">
      ${['Linen shirt', 'Canvas tote', 'Cotton knit', 'Soft scarf']
        .map(
          (n, i) =>
            `<article><div class="h-28 rounded-2xl" style="background:${
              ['#DCCDBD', '#B99068', '#A8B8B4', '#D8A58D'][i]
            }"></div><strong class="mt-3 block text-sm">${n}</strong><span class="text-xs text-slateink/55">€${
              [54, 35, 68, 42][i]
            }.00</span></article>`
        )
        .join('')}
    </section>
  </main>`;
      }

      function stickyButton() {
        const s = state.settings;
        const alignment =
          s.position === 'left'
            ? 'left:20px;right:auto;transform:none'
            : s.position === 'center'
            ? 'left:50%;right:auto;transform:translateX(-50%)'
            : 'right:20px;left:auto;transform:none';
        return `<button id="openWithdrawal" class="absolute bottom-5 z-20 max-w-[calc(100%-2.5rem)] whitespace-nowrap font-semibold shadow-float" style="${alignment};background:${
          s.color
        };color:${s.textColor};padding:${s.verticalPadding}px ${s.horizontalPadding}px;font-size:${
          s.fontSize
        }px;border:${s.borderWidth}px solid ${s.borderColor};border-radius:${s.radius}px">${esc(
          s.buttonText
        )}</button>`;
      }

      function popupForm() {
        return `<div id="drawerOverlay" class="pointer-events-none absolute inset-0 z-30 bg-navy/0 transition-colors duration-300">
    <div id="withdrawalDrawer" class="absolute inset-y-0 right-0 w-full max-w-[540px] translate-x-full overflow-y-auto overscroll-contain bg-white p-5 shadow-panel transition-transform duration-300 ease-out sm:p-6">
      <div class="flex items-start justify-between gap-4">
        <div>
          <span class="text-[11px] font-black uppercase tracking-[.18em] text-coral">${ui('euWithdrawal')}</span>
          <h2 class="mt-1 text-xl font-black">${tr('title')}</h2>
        </div>
        <button id="closePopup" class="grid h-9 w-9 place-items-center rounded-full bg-mist font-black">×</button>
      </div>
      <div class="mt-4">${customerForm()}</div>
    </div>
  </div>`;
      }

      function formPage() {
        if (!state.settings.pageEnabled) {
          return `<main class="grid h-full place-items-center p-8 text-center">
      <div>
        <h2 class="text-3xl font-black">${ui('dedicatedPage')}</h2>
        <p class="mt-3 text-slateink/60">${ui('enableWithdrawalPage')}</p>
      </div>
    </main>`;
        }

        return `<div class="flex h-full flex-col bg-white">
    <header class="flex h-[64px] shrink-0 items-center justify-between border-b border-navy/10 px-5 sm:px-7">
      <strong class="text-lg tracking-[-.03em]">ATELIER NORTH</strong>
      <nav class="hidden gap-6 text-[11px] font-black uppercase tracking-[.13em] text-slateink/55 sm:flex">
        <span>${ui('shop')}</span>
        <span>${ui('stories')}</span>
        <span>${ui('about')}</span>
        <span>${ui('bag')}</span>
      </nav>
      <span class="sm:hidden">☰</span>
    </header>

    <main class="min-h-0 flex-1 overflow-y-auto bg-[#fbfbfb] p-5 sm:p-8">
      <section class="mx-auto max-w-[700px] overflow-hidden rounded-[20px] border border-[#d9dde4] bg-white shadow-sm">
        <div class="border-b border-[#e0e3e8] px-7 py-7 sm:px-8">
          <h2 class="text-3xl font-medium tracking-[-.02em] text-[#171717]">${tr('title')}</h2>
          <p class="mt-3 text-[15px] leading-6 text-[#6b7280]">${tr('intro')}</p>
        </div>

        <div class="px-7 py-7 sm:px-8">
          ${dedicatedPageForm()}
        </div>
      </section>
    </main>
  </div>`;
      }

      function dedicatedPageForm() {
        if (state.submitted) return successPanel();

        return `<form id="customerForm" class="space-y-5">
    ${dedicatedField('fullName', tr('fullName'), '', state.fullName, true)}
    ${dedicatedField('email', tr('email'), '', state.email, true, 'email')}

    <div>
      ${dedicatedField('orderId', tr('order'), '1001', state.orderId, true)}
      <div id="orderVerificationResult" class="mt-3">
        ${orderVerificationContent()}
      </div>
    </div>

    <label class="block">
      <span class="text-[13px] font-black uppercase tracking-[.03em] text-[#171717]">${tr('note')}</span>
      <textarea id="note" rows="6" class="mt-2 w-full resize-y rounded-lg border border-[#cfd5dd] px-3 py-3 text-sm outline-none focus:border-[#8a94a3]" placeholder="${esc(
        tr('notePlaceholder') || tr('note')
      )}">${esc(state.note)}</textarea>
    </label>

    <button id="submitWithdrawalButton" type="submit"
      class="w-full rounded-lg px-5 py-3.5 text-base font-black text-white transition ${
        state.verification === 'success' ? 'bg-[#2f2f2f]' : 'cursor-not-allowed bg-[#9a9a9a]'
      }"
      ${state.verification === 'success' ? '' : 'disabled'}>
      ${tr('submit')}
    </button>

    <p class="text-center text-[12px] leading-5 text-[#46526a]">
      <strong>Compliance note:</strong>
      EU Directive 2023/2673 requires online retailers to provide electronic cancellation from June 19, 2026.
    </p>
  </form>`;
      }

      function dedicatedField(id, label, placeholder, value, required = false, type = 'text') {
        return `<label class="block">
    <span class="text-[13px] font-black uppercase tracking-[.03em] text-[#171717]">
      ${label}${required ? ` <span class="text-red-600">*</span>` : ''}
    </span>
    <input id="${id}" type="${type}" value="${esc(value)}" placeholder="${esc(placeholder)}"
      class="mt-2 w-full rounded-lg border border-[#cfd5dd] px-3 py-3 text-sm outline-none focus:border-[#8a94a3]">
  </label>`;
      }

      function customerForm() {
        if (state.submitted) return successPanel();
        return `<div>
    ${
      state.mode === 'page'
        ? `<h3 class="text-3xl font-black">${tr('title')}</h3><p class="mt-3 leading-7 text-slateink/60">${tr(
            'intro'
          )}</p>`
        : ''
    }
    <form id="customerForm" class="${state.mode === 'page' ? 'mt-7' : ''} space-y-4">
      <div class="grid gap-4 sm:grid-cols-2">${input('fullName', tr('fullName'), 'Anna Müller', state.fullName)}${input(
          'email',
          tr('email'),
          'anna@example.com',
          state.email,
          'email'
        )}</div>

      <div>
        ${input('orderId', tr('order'), '1048', state.orderId)}
        <div id="orderVerificationResult" class="mt-3">
          ${orderVerificationContent()}
        </div>
      </div>

      <label class="block"><span class="text-sm font-black">${tr(
        'note'
      )}</span><textarea id="note" rows="3" class="mt-2 w-full resize-none rounded-xl border border-navy/15 px-4 py-3 outline-none focus:border-coral" placeholder="${esc(
          tr('note')
        )}">${esc(state.note)}</textarea></label>

      <button id="submitWithdrawalButton" type="submit" class="w-full rounded-xl px-5 py-3.5 text-sm font-black text-white transition ${
        state.verification === 'success' ? 'bg-coral' : 'cursor-not-allowed bg-slateink/35'
      }" ${state.verification === 'success' ? '' : 'disabled'}>${tr('submit')}</button>
    </form>
  </div>`;
      }

      function orderVerificationContent() {
        if (!state.orderId.trim()) {
          return `<div class="rounded-xl border border-dashed border-navy/20 bg-mist/50 p-4 text-sm text-slateink/60"><strong>${ui(
            'testCases'
          )}:</strong> #9999 · wrong@example.com</div>`;
        }

        if (state.verification === 'notFound') return errorBox(tr('notFound'));
        if (state.verification === 'mismatch') return errorBox(tr('mismatch'));
        if (state.verification === 'required') return errorBox(tr('required'));

        if (state.verification === 'success') {
          return `
      <div class="flex items-center gap-3 rounded-xl border border-aqua/30 bg-aqua/10 p-4 text-sm font-bold text-aqua">
        <span class="grid h-7 w-7 place-items-center rounded-full bg-aqua text-white">✓</span>
        ${tr('found')}
      </div>
      <div class="mt-3">${itemsPanel()}</div>
    `;
        }

        return `<div class="rounded-xl border border-dashed border-navy/20 bg-mist/50 p-4 text-sm text-slateink/60"><strong>${ui(
          'testCases'
        )}:</strong> #9999 · wrong@example.com</div>`;
      }

      function updateOrderVerificationUI() {
        const result = $('#orderVerificationResult');
        if (result) result.innerHTML = orderVerificationContent();

        const submitButton = $('#submitWithdrawalButton');
        if (submitButton) {
          const enabled = state.verification === 'success';
          submitButton.disabled = !enabled;
          submitButton.textContent = tr('submit');
          submitButton.className = enabled
            ? 'w-full rounded-xl bg-coral px-5 py-3.5 text-sm font-black text-white transition'
            : 'w-full cursor-not-allowed rounded-xl bg-slateink/35 px-5 py-3.5 text-sm font-black text-white transition';
        }

        bindProductCheckboxes();
      }

      function bindProductCheckboxes() {
        $$('.product-check').forEach((input) => {
          input.onchange = () => {
            if (input.checked) state.selected.add(input.dataset.id);
            else state.selected.delete(input.dataset.id);
            updateOrderVerificationUI();
          };
        });
      }

      function input(id, label, placeholder, value, type = 'text') {
        return `<label class="block"><span class="text-sm font-black">${label}</span><input id="${id}" type="${type}" value="${esc(
          value
        )}" placeholder="${esc(
          placeholder
        )}" class="mt-2 w-full rounded-xl border border-navy/15 px-4 py-3 outline-none focus:border-coral"></label>`;
      }

      function errorBox(message) {
        return `<div class="flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-700"><span class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-red-600 text-white">!</span><span>${message}</span></div>`;
      }

      function itemsPanel() {
        return `<section class="rounded-2xl border border-navy/10 bg-mist/50 p-4">
    <div class="flex items-center justify-between gap-4"><div><span class="text-xs font-black uppercase tracking-[.15em] text-aqua">${tr(
      'found'
    )}</span><strong class="mt-1 block">${ui('orderWord')} 1048</strong></div><strong>${tr(
          'total'
        )}: €89.00</strong></div>
    <p class="mt-5 text-sm font-black">${tr('choose')}</p><div class="mt-3 space-y-3">${products
          .map(productCard)
          .join('')}</div>
  </section>`;
      }

      function productCard(p) {
        const checked = state.selected.has(p.id);
        return `<label class="flex cursor-pointer items-center gap-3 rounded-xl border ${
          checked ? 'border-coral bg-white' : 'border-navy/10 bg-white/70'
        } p-3"><input class="product-check h-4 w-4 accent-coral" type="checkbox" data-id="${p.id}" ${
          checked ? 'checked' : ''
        }><div class="h-14 w-14 rounded-lg" style="background:${
          p.color
        }"></div><div class="min-w-0 flex-1"><strong class="block truncate text-sm">${
          p.name
        }</strong><span class="text-xs text-slateink/50">${
          p.variant
        }</span></div><strong class="text-sm">€${p.price.toFixed(2)}</strong></label>`;
      }

      function successPanel() {
        return `<div class="py-8 text-center"><div class="mx-auto grid h-20 w-20 place-items-center rounded-full bg-aqua text-3xl text-white">✓</div><h3 class="mt-6 text-3xl font-black">${tr(
          'success'
        )}</h3><p class="mx-auto mt-3 max-w-md leading-7 text-slateink/60">${tr(
          'successBody'
        )}</p><div class="mx-auto mt-7 max-w-md rounded-2xl bg-mist p-5 text-left text-sm"><div class="flex justify-between"><span>Reference</span><strong>WR-2026-015</strong></div><div class="mt-3 flex justify-between"><span>${tr(
          'order'
        )}</span><strong>1048</strong></div></div><button id="closeSuccess" class="mt-7 rounded-full bg-navy px-6 py-3 text-sm font-black text-white">${tr(
          'close'
        )}</button></div>`;
      }

      function requestsView() {
        const selected = state.requests.find((r) => r.id === state.selectedRequest) || state.requests[0];

        return `<div class="h-[720px] overflow-hidden bg-[#f1f1f1] text-[#303030]">
    <div class="flex h-full">
      ${shopifyAdminSidebar('requests')}

      <div class="flex min-w-0 flex-1 flex-col">
        ${shopifyAdminTopbar()}

        <main class="min-h-0 flex-1 overflow-y-auto">
          <div class="mx-auto max-w-[1240px] px-5 py-6 lg:px-8">
            <div class="flex flex-wrap items-center justify-between gap-4">
              <div class="flex items-center gap-3">
                <button class="grid h-9 w-9 place-items-center rounded-lg border border-[#d4d4d4] bg-white text-lg shadow-sm">←</button>
                <div>
                  <div class="flex items-center gap-2">
                    <h2 class="text-[20px] font-semibold tracking-[-.02em] text-[#303030]">${ui(
                      'withdrawalRequests'
                    )}</h2>
                    <span class="rounded-md bg-[#e3e3e3] px-2 py-1 text-[11px] font-semibold text-[#616161]">App</span>
                  </div>
                  <p class="mt-1 text-[13px] text-[#616161]">Slash EU Withdrawal Button</p>
                </div>
              </div>

              <div class="flex gap-2">
                <button class="rounded-lg border border-[#c9c9c9] bg-white px-3.5 py-2 text-[13px] font-semibold shadow-sm">${ui(
                  'exportCsv'
                )}</button>
                <button class="rounded-lg bg-[#303030] px-3.5 py-2 text-[13px] font-semibold text-white shadow-sm">•••</button>
              </div>
            </div>

            <div class="mt-5 grid gap-3 sm:grid-cols-3">
              ${shopifyMetric('4', ui('totalRequests'), ui('thisMonth'))}
              ${shopifyMetric('1', ui('pending'), ui('needsReview'))}
              ${shopifyMetric('€199', ui('requestedValue'), ui('thisMonth'))}
            </div>

            <section class="mt-5 overflow-hidden rounded-xl border border-[#d4d4d4] bg-white shadow-[0_1px_0_rgba(0,0,0,.04)]">
              <div class="border-b border-[#e3e3e3] px-4 pt-3">
                <div class="flex gap-1 overflow-x-auto">
                  ${['All', 'Pending', 'Approved', 'Completed', 'Rejected']
                    .map(
                      (label, index) => `
                    <button class="whitespace-nowrap border-b-2 px-3 py-2 text-[13px] font-semibold ${
                      index === 0 ? 'border-[#303030] text-[#303030]' : 'border-transparent text-[#616161]'
                    }">
                      ${
                        label === 'Pending'
                          ? ui('pending')
                          : label === 'Approved'
                          ? ui('approved')
                          : label === 'Completed'
                          ? ui('completed')
                          : label === 'Rejected'
                          ? ui('rejected')
                          : label
                      }
                    </button>
                  `
                    )
                    .join('')}
                  <button class="px-3 py-2 text-[13px] font-semibold text-[#616161]">＋</button>
                </div>
              </div>

              <div class="flex flex-wrap items-center gap-2 border-b border-[#e3e3e3] p-3">
                <div class="relative min-w-[220px] flex-1">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 text-[#616161]">⌕</span>
                  <input class="w-full rounded-lg border border-[#c9c9c9] bg-white py-2 pl-9 pr-3 text-[13px] outline-none focus:border-[#005bd3] focus:ring-1 focus:ring-[#005bd3]" placeholder="Search requests">
                </div>
                <button class="rounded-lg border border-[#c9c9c9] bg-white px-3 py-2 text-[13px] font-semibold">☷ ${ui(
                  'status'
                )}</button>
                <button class="rounded-lg border border-[#c9c9c9] bg-white px-3 py-2 text-[13px] font-semibold">↕ Sort</button>
              </div>

              <div class="grid xl:grid-cols-[1fr_340px]">
                <div class="min-w-0 overflow-x-auto">
                  <table class="w-full min-w-[760px] border-collapse text-left text-[13px]">
                    <thead>
                      <tr class="border-b border-[#e3e3e3] bg-[#fafafa] text-[#616161]">
                        <th class="w-10 px-4 py-3"><input type="checkbox" class="h-4 w-4 rounded border-[#8a8a8a]"></th>
                        <th class="px-3 py-3 font-semibold">${ui('request')}</th>
                        <th class="px-3 py-3 font-semibold">${ui('customer')}</th>
                        <th class="px-3 py-3 font-semibold">${ui('items')}</th>
                        <th class="px-3 py-3 font-semibold">${ui('status')}</th>
                        <th class="px-3 py-3 font-semibold">Submitted</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${state.requests
                        .map(
                          (r) => `
                        <tr class="open-request cursor-pointer border-b border-[#ededed] hover:bg-[#f7f7f7] ${
                          r.id === state.selectedRequest ? 'bg-[#f3f3f3]' : ''
                        }" data-id="${r.id}">
                          <td class="px-4 py-3"><input type="checkbox" class="h-4 w-4 rounded border-[#8a8a8a]"></td>
                          <td class="px-3 py-3">
                            <strong class="block font-semibold text-[#005bd3]">${r.id}</strong>
                            <span class="mt-0.5 block text-[12px] text-[#616161]">${r.order}</span>
                          </td>
                          <td class="px-3 py-3">
                            <strong class="block font-medium">${r.customer}</strong>
                            <span class="mt-0.5 block text-[12px] text-[#616161]">${r.email}</span>
                          </td>
                          <td class="px-3 py-3">${r.items} · ${r.amount}</td>
                          <td class="px-3 py-3">${shopifyStatus(r.status)}</td>
                          <td class="px-3 py-3 text-[#616161]">${r.date === 'Just now' ? ui('justNow') : r.date}</td>
                        </tr>
                      `
                        )
                        .join('')}
                    </tbody>
                  </table>

                  <div class="flex items-center justify-center gap-2 p-4">
                    <button class="rounded-lg border border-[#c9c9c9] bg-white px-3 py-1.5 text-[#8a8a8a]">‹</button>
                    <button class="rounded-lg border border-[#c9c9c9] bg-white px-3 py-1.5">›</button>
                  </div>
                </div>

                ${shopifyRequestDetail(selected)}
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  </div>`;
      }

      function shopifyAdminTopbar() {
        return `<header class="flex h-14 shrink-0 items-center gap-3 border-b border-[#d4d4d4] bg-white px-4">
    <button class="grid h-8 w-8 place-items-center rounded-lg text-lg hover:bg-[#f1f1f1]">☰</button>
    <div class="relative mx-auto w-full max-w-[620px]">
      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-[#616161]">⌕</span>
      <div class="rounded-lg border border-[#c9c9c9] bg-[#f7f7f7] py-2 pl-9 pr-16 text-[13px] text-[#616161]">Search</div>
      <span class="absolute right-3 top-1/2 -translate-y-1/2 rounded border border-[#d4d4d4] bg-white px-1.5 py-0.5 text-[11px] text-[#616161]">⌘ K</span>
    </div>
    <button class="grid h-8 w-8 place-items-center rounded-lg hover:bg-[#f1f1f1]">◔</button>
    <button class="flex items-center gap-2 rounded-lg p-1.5 hover:bg-[#f1f1f1]">
      <span class="grid h-7 w-7 place-items-center rounded-lg bg-[#8c6b4a] text-[11px] font-bold text-white">AN</span>
      <span class="hidden text-[13px] font-semibold sm:block">Atelier North</span>
    </button>
  </header>`;
      }

      function shopifyAdminSidebar(active) {
        const nav = [
          ['home', '⌂', 'Home'],
          ['orders', '▣', 'Orders'],
          ['products', '◇', 'Products'],
          ['customers', '♙', 'Customers'],
          ['content', '▤', 'Content'],
          ['analytics', '↗', 'Analytics'],
          ['marketing', '◎', 'Marketing'],
          ['discounts', '％', 'Discounts'],
        ];

        return `<aside class="hidden w-[226px] shrink-0 border-r border-[#d4d4d4] bg-[#ebebeb] lg:flex lg:flex-col">
    <div class="flex h-14 items-center gap-2 px-3">
      <span class="grid h-8 w-8 place-items-center rounded-lg bg-[#95bf47] font-black text-white">S</span>
      <strong class="text-[14px]">Atelier North</strong>
    </div>

    <nav class="px-2">
      ${nav
        .map(
          ([id, icon, label]) => `
        <div class="flex items-center gap-3 rounded-lg px-3 py-2 text-[13px] ${
          id === active ? 'bg-[#dcdcdc] font-semibold' : 'text-[#303030] hover:bg-[#e1e1e1]'
        }">
          <span class="w-4 text-center">${icon}</span><span>${label}</span>
        </div>
      `
        )
        .join('')}
    </nav>

    <div class="mt-5 px-3 text-[12px] font-semibold text-[#616161]">Sales channels</div>
    <div class="mt-1 px-2">
      <div class="flex items-center gap-3 rounded-lg px-3 py-2 text-[13px]"><span>◉</span>Online Store</div>
    </div>

    <div class="mt-5 px-3 text-[12px] font-semibold text-[#616161]">Apps</div>
    <div class="mt-1 px-2">
      <div class="flex items-center gap-3 rounded-lg bg-[#dcdcdc] px-3 py-2 text-[13px] font-semibold">
        <span class="grid h-5 w-5 place-items-center rounded bg-[#303030] text-[10px] text-white">S</span>
        Slash Withdrawal
      </div>
    </div>

    <div class="mt-auto border-t border-[#d4d4d4] p-2">
      <div class="flex items-center gap-3 rounded-lg px-3 py-2 text-[13px]"><span>⚙</span>${
        state.language === 'de' ? 'Einstellungen' : 'Settings'
      }</div>
    </div>
  </aside>`;
      }

      function shopifyMetric(value, label, note) {
        return `<article class="rounded-xl border border-[#d4d4d4] bg-white p-4 shadow-[0_1px_0_rgba(0,0,0,.04)]">
    <div class="text-[12px] font-medium text-[#616161]">${label}</div>
    <div class="mt-2 text-[24px] font-semibold tracking-[-.03em]">${value}</div>
    <div class="mt-1 text-[12px] text-[#616161]">${note}</div>
  </article>`;
      }

      function shopifyStatus(statusValue) {
        const config = {
          Pending: ['bg-[#fff1e3] text-[#8a4b00]', ui('pending')],
          Approved: ['bg-[#e8f0fe] text-[#174ea6]', ui('approved')],
          Completed: ['bg-[#e3f1df] text-[#1f6f35]', ui('completed')],
          Rejected: ['bg-[#fee9e8] text-[#8e1f0b]', ui('rejected')],
        };
        const [classes, label] = config[statusValue] || ['bg-[#e3e3e3] text-[#303030]', statusValue];
        return `<span class="inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-[12px] font-semibold ${classes}">
    <span class="h-1.5 w-1.5 rounded-full bg-current"></span>${label}
  </span>`;
      }

      function shopifyRequestDetail(request) {
        return `<aside class="border-l border-[#e3e3e3] bg-[#fafafa] p-5">
    <div class="flex items-start justify-between gap-3">
      <div>
        <p class="text-[12px] font-semibold uppercase tracking-[.08em] text-[#616161]">${ui('requestDetail')}</p>
        <h3 class="mt-1 text-[18px] font-semibold">${request.id}</h3>
      </div>
      ${shopifyStatus(request.status)}
    </div>

    <div class="mt-5 space-y-4 text-[13px]">
      <div>
        <div class="text-[12px] text-[#616161]">${ui('customer')}</div>
        <a class="mt-1 block font-semibold text-[#005bd3]">${request.customer}</a>
        <div class="text-[#616161]">${request.email}</div>
      </div>

      <div class="border-t border-[#e3e3e3] pt-4">
        <div class="text-[12px] text-[#616161]">${ui('orderLabel')}</div>
        <a class="mt-1 block font-semibold text-[#005bd3]">${request.order}</a>
        <div class="text-[#616161]">${request.items} ${ui('items').toLowerCase()} · ${request.amount}</div>
      </div>

      <div class="border-t border-[#e3e3e3] pt-4">
        <div class="text-[12px] text-[#616161]">${ui('additionalNote')}</div>
        <p class="mt-2 rounded-lg border border-[#e3e3e3] bg-white p-3 leading-5">
          ${request.note === 'No additional note.' ? ui('noAdditionalNote') : request.note}
        </p>
      </div>
    </div>

    ${
      request.status === 'Pending'
        ? `
      <div class="mt-5 flex gap-2 border-t border-[#e3e3e3] pt-4">
        <button id="rejectRequest" class="flex-1 rounded-lg border border-[#c9c9c9] bg-white px-3 py-2 text-[13px] font-semibold">${ui(
          'reject'
        )}</button>
        <button id="approveRequest" class="flex-1 rounded-lg bg-[#303030] px-3 py-2 text-[13px] font-semibold text-white">${ui(
          'approve'
        )}</button>
      </div>
    `
        : `
      <button class="mt-5 w-full rounded-lg border border-[#c9c9c9] bg-white px-3 py-2 text-[13px] font-semibold">${ui(
        'openShopifyOrder'
      )}</button>
    `
    }
  </aside>`;
      }

      function settingsView() {
        return `<div class="h-[720px] overflow-hidden bg-[#f1f1f1] text-[#303030]"><div class="flex h-full">${shopifyAdminSidebar(
          'apps'
        )}<div class="flex min-w-0 flex-1 flex-col">${shopifyAdminTopbar()}<div class="grid min-h-0 flex-1 overflow-hidden lg:grid-cols-[390px_1fr]">
    <aside class="overflow-y-auto border-r border-[#d4d4d4] bg-white p-6"><p class="text-xs font-black uppercase tracking-[.16em] text-coral">${ui(
      'appConfiguration'
    )}</p><h2 class="mt-2 text-2xl font-black">${ui('buttonAndForm')}</h2>
      <div class="mt-7 space-y-6">
        ${input('settingText', ui('buttonLabel'), '', state.settings.buttonText)}
        <div><span class="text-sm font-black">${ui('buttonColor')}</span><div class="mt-2 flex gap-3">${[
          '#EE6C4D',
          '#10243E',
          '#2A9D8F',
          '#8B5CF6',
        ]
          .map(
            (c) =>
              `<button class="setting-color h-10 flex-1 rounded-xl border-2 ${
                c === state.settings.color ? 'border-navy' : 'border-transparent'
              }" data-color="${c}" style="background:${c}"></button>`
          )
          .join('')}</div></div>
        <div><span class="text-sm font-black">${ui(
          'position'
        )}</span><div class="mt-2 grid grid-cols-2 gap-2"><button class="setting-position rounded-xl border px-4 py-3 text-sm font-black ${
          state.settings.position === 'left' ? 'border-coral text-coral' : 'border-navy/10'
        }" data-position="left">${ui(
          'bottomLeft'
        )}</button><button class="setting-position rounded-xl border px-4 py-3 text-sm font-black ${
          state.settings.position === 'right' ? 'border-coral text-coral' : 'border-navy/10'
        }" data-position="right">${ui('bottomRight')}</button></div></div>
        <label class="flex items-center justify-between rounded-xl border border-navy/10 p-4"><span><strong class="block text-sm">${ui(
          'popupForm'
        )}</strong><small class="text-slateink/45">${ui(
          'showFormModal'
        )}</small></span><input id="popupEnabled" type="checkbox" class="h-5 w-5 accent-coral" ${
          state.settings.popupEnabled ? 'checked' : ''
        }></label>
        <label class="flex items-center justify-between rounded-xl border border-navy/10 p-4"><span><strong class="block text-sm">${ui(
          'dedicatedPage'
        )}</strong><small class="text-slateink/45">${ui(
          'enableWithdrawalPage'
        )}</small></span><input id="pageEnabled" type="checkbox" class="h-5 w-5 accent-coral" ${
          state.settings.pageEnabled ? 'checked' : ''
        }></label>
        <button id="saveSettings" class="w-full rounded-xl bg-navy px-5 py-4 text-sm font-black text-white">${ui(
          'saveSettings'
        )}</button>
      </div>
    </aside>
    <main class="overflow-y-auto bg-[#f1f1f1] p-5 sm:p-8"><div class="mx-auto max-w-xl"><div class="mb-4 flex items-center justify-between"><strong>${ui(
      'liveStorefrontPreview'
    )}</strong><span class="rounded-full bg-aqua/15 px-3 py-1.5 text-xs font-black text-aqua">${ui(
          'active'
        )}</span></div><div class="relative min-h-[580px] overflow-hidden rounded-xl border border-[#d4d4d4] bg-white shadow-sm"><header class="flex items-center justify-between border-b border-navy/10 px-5 py-4"><strong>ATELIER NORTH</strong><span>${ui(
          'bag'
        )}</span></header><div class="grid min-h-[330px] place-items-center bg-[#E8DDD0] p-8 text-center"><div><p class="text-xs font-black uppercase tracking-[.16em] text-coral">${ui(
          'newSeason'
        )}</p><h3 class="mt-4 text-4xl font-black">${ui(
          'thoughtfulGoods'
        )}</h3></div></div><div class="grid grid-cols-2 gap-3 p-5"><div class="h-36 rounded-xl bg-[#DCCDBD]"></div><div class="h-36 rounded-xl bg-[#B99068]"></div></div><button class="absolute bottom-5 ${
          state.settings.position === 'right' ? 'right-5' : 'left-5'
        } px-5 py-3.5 text-sm font-black text-white shadow-float" style="background:${
          state.settings.color
        };border-radius:999px">${esc(state.settings.buttonText)}</button></div></div></main>
  </div>`;
      }

      function updateStickyButtonPreview() {
        const button = $('#openWithdrawal');
        if (!button) return;

        const s = state.settings;
        button.textContent = s.buttonText;
        button.style.background = s.color;
        button.style.color = s.textColor;
        button.style.padding = `${s.verticalPadding}px ${s.horizontalPadding}px`;
        button.style.fontSize = `${s.fontSize}px`;
        button.style.border = `${s.borderWidth}px solid ${s.borderColor}`;
        button.style.borderRadius = `${s.radius}px`;

        button.style.left = '';
        button.style.right = '';
        button.style.transform = '';
        if (s.position === 'left') {
          button.style.left = '20px';
        } else if (s.position === 'center') {
          button.style.left = '50%';
          button.style.transform = 'translateX(-50%)';
        } else {
          button.style.right = '20px';
        }

        $$('.sticky-align').forEach((control) => {
          const active = control.dataset.position === s.position;
          control.className = `sticky-align px-2 py-2 text-xs ${
            active ? 'bg-white font-semibold shadow-sm' : 'bg-[#f4f4f4]'
          }`;
        });
      }

      function setRangeControl(id, stateKey) {
        const input = $('#' + id);
        const value = $('#' + id + 'Value');
        if (!input) return;
        input.oninput = () => {
          state.settings[stateKey] = Number(input.value);
          if (value) value.textContent = input.value;
          updateStickyButtonPreview();
        };
      }

      function normalizeHex(value, fallback) {
        const candidate = String(value || '').trim();
        return /^#[0-9a-fA-F]{6}$/.test(candidate) ? candidate.toUpperCase() : fallback;
      }

      function setColorControl(id, stateKey) {
        const picker = $('#' + id);
        const text = $('#' + id + 'Text');
        if (!picker || !text) return;

        picker.oninput = () => {
          const value = picker.value.toUpperCase();
          state.settings[stateKey] = value;
          text.value = value;
          updateStickyButtonPreview();
        };

        text.onchange = () => {
          const value = normalizeHex(text.value, state.settings[stateKey]);
          state.settings[stateKey] = value;
          text.value = value;
          picker.value = value;
          updateStickyButtonPreview();
        };
      }

      function bindStickyButtonControls() {
        const text = $('#stickyButtonText');
        if (text) {
          text.oninput = () => {
            state.settings.buttonText = text.value || tr('button');
            updateStickyButtonPreview();
          };
        }

        $$('.sticky-align').forEach((control) => {
          control.onclick = () => {
            state.settings.position = control.dataset.position;
            updateStickyButtonPreview();
          };
        });

        setRangeControl('stickyVerticalPadding', 'verticalPadding');
        setRangeControl('stickyHorizontalPadding', 'horizontalPadding');
        setRangeControl('stickyFontSize', 'fontSize');
        setRangeControl('stickyBorderWidth', 'borderWidth');
        setRangeControl('stickyBorderRadius', 'radius');

        setColorControl('stickyBackgroundColor', 'color');
        setColorControl('stickyTextColor', 'textColor');
        setColorControl('stickyBorderColor', 'borderColor');
      }

      function openDrawer() {
        state.popup = true;
        const overlay = $('#drawerOverlay');
        const drawer = $('#withdrawalDrawer');
        if (!overlay || !drawer) return;
        overlay.classList.remove('pointer-events-none', 'bg-navy/0');
        overlay.classList.add('pointer-events-auto', 'bg-navy/35');
        drawer.classList.remove('translate-x-full');
        drawer.classList.add('translate-x-0');
      }

      function closeDrawer() {
        state.popup = false;
        const overlay = $('#drawerOverlay');
        const drawer = $('#withdrawalDrawer');
        if (!overlay || !drawer) return;
        overlay.classList.remove('pointer-events-auto', 'bg-navy/35');
        overlay.classList.add('pointer-events-none', 'bg-navy/0');
        drawer.classList.remove('translate-x-0');
        drawer.classList.add('translate-x-full');
      }

      function bindView() {
        if (state.view === 'storefront') {
          if (state.mode === 'popup') bindStickyButtonControls();
          $('#openWithdrawal')?.addEventListener('click', openDrawer);
          $('#closePopup')?.addEventListener('click', closeDrawer);
          $('#fullName')?.addEventListener('input', (e) => {
            state.fullName = e.target.value;
            if (state.orderId.trim()) runLiveVerification();
          });
          $('#email')?.addEventListener('input', (e) => {
            state.email = e.target.value;
            if (state.orderId.trim()) runLiveVerification();
          });
          $('#orderId')?.addEventListener('input', (e) => {
            state.orderId = e.target.value;
            runLiveVerification();
          });
          $('#note')?.addEventListener('input', (e) => (state.note = e.target.value));
          bindProductCheckboxes();
          $('#customerForm')?.addEventListener('submit', (e) => {
            e.preventDefault();
            if (state.verification !== 'success') {
              return;
            }
            if (state.selected.size === 0) {
              toast(tr('pick'));
              return;
            }
            state.submitted = true;
            state.requests.unshift({
              id: 'WR-2026-015',
              order: '1048',
              customer: state.fullName,
              email: state.email,
              items: state.selected.size,
              amount: state.selected.size === 2 ? '€89.00' : state.selected.has('shirt') ? '€54.00' : '€35.00',
              date: 'Just now',
              status: 'Pending',
              note: state.note || 'No additional note.',
            });
            render();
          });
          $('#closeSuccess')?.addEventListener('click', () => {
            resetCustomerFlow(true);
            render();
          });
        }
        if (state.view === 'requests') {
          $$('.open-request').forEach(
            (b) =>
              (b.onclick = () => {
                state.selectedRequest = b.dataset.id;
                render();
              })
          );
          $('#approveRequest')?.addEventListener('click', () => changeRequestStatus('Approved'));
          $('#rejectRequest')?.addEventListener('click', () => changeRequestStatus('Rejected'));
        }
        if (state.view === 'settings') {
          $('#settingText')?.addEventListener('input', (e) => {
            state.settings.buttonText = e.target.value;
            render();
          });
          $$('.setting-color').forEach(
            (b) =>
              (b.onclick = () => {
                state.settings.color = b.dataset.color;
                render();
              })
          );
          $$('.setting-position').forEach(
            (b) =>
              (b.onclick = () => {
                state.settings.position = b.dataset.position;
                render();
              })
          );
          $('#popupEnabled')?.addEventListener('change', (e) => {
            state.settings.popupEnabled = e.target.checked;
            render();
          });
          $('#pageEnabled')?.addEventListener('change', (e) => {
            state.settings.pageEnabled = e.target.checked;
            render();
          });
          $('#saveSettings')?.addEventListener('click', () => toast(ui('settingsSaved')));
        }
      }

      function runLiveVerification() {
        const orderInput = $('#orderId');
        const emailInput = $('#email');
        const nameInput = $('#fullName');

        if (orderInput) state.orderId = orderInput.value.trim().replace(/^#/, '');
        if (emailInput) state.email = emailInput.value.trim();
        if (nameInput) state.fullName = nameInput.value.trim();

        if (!state.orderId) {
          state.verification = 'idle';
          state.selected.clear();
          updateOrderVerificationUI();
          return;
        }

        if (state.orderId !== '1048') {
          state.verification = 'notFound';
          state.selected.clear();
          updateOrderVerificationUI();
          return;
        }

        if (!state.email) {
          state.verification = 'required';
          state.selected.clear();
          updateOrderVerificationUI();
          return;
        }

        if (state.email.toLowerCase() !== 'anna@example.com') {
          state.verification = 'mismatch';
          state.selected.clear();
          updateOrderVerificationUI();
          return;
        }

        state.verification = 'success';
        updateOrderVerificationUI();
      }

      function changeRequestStatus(statusValue) {
        const request = state.requests.find((x) => x.id === state.selectedRequest);
        if (request) request.status = statusValue;
        toast(statusValue === 'Approved' ? ui('requestApproved') : ui('requestRejected'));
        render();
      }

      function resetCustomerFlow(close) {
        state.verification = 'idle';
        state.orderId = '';
        state.email = '';
        state.fullName = '';
        state.note = '';
        state.selected = new Set();
        state.submitted = false;
        if (close) state.popup = false;
      }

      function toast(message) {
        const el = $('#toast');
        el.textContent = message;
        el.classList.remove('hidden');
        clearTimeout(toast.timer);
        toast.timer = setTimeout(() => el.classList.add('hidden'), 2400);
      }

      function markAdminClickables() {}

      function adminGo(page) {
        const preview = $('#appPreview');
        const previousScroll = preview ? preview.scrollTop : 0;
        state.adminPage = page;
        state.view = 'requests';
        render();
        if (preview) preview.scrollTop = previousScroll;
      }
      function openWithdrawalDetail() {
        state.adminPage = 'detail';
        render();
      }
      function setEmailTemplate(type) {
        state.emailTemplate = type;
        render();
      }
      function setEmailLocale(locale) {
        state.emailLocale = locale;
        render();
      }
      const BACKEND_LANGUAGES = [
        ['en', 'English'],
        ['de', 'German'],
        ['nl', 'Dutch'],
        ['fr', 'French'],
        ['el', 'Greek'],
        ['fi', 'Finnish'],
        ['sv', 'Swedish'],
        ['hu', 'Hungarian'],
        ['ga', 'Irish'],
        ['it', 'Italian'],
        ['pl', 'Polish'],
        ['ro', 'Romanian'],
        ['pt', 'Portuguese (Portugal)'],
        ['es', 'Spanish'],
        ['cs', 'Czech'],
        ['da', 'Danish'],
        ['et', 'Estonian'],
        ['lv', 'Latvian'],
        ['lt', 'Lithuanian'],
        ['mt', 'Maltese'],
        ['sk', 'Slovak'],
        ['sl', 'Slovenian'],
        ['hr', 'Croatian'],
      ];
      const BACKEND_I18N = {
        en: {
          home: 'Home',
          orders: 'Orders',
          products: 'Products',
          customers: 'Customers',
          growth: 'Growth',
          discounts: 'Discounts',
          content: 'Content',
          markets: 'Markets',
          finance: 'Finance',
          analytics: 'Analytics',
          salesChannels: 'Sales channels',
          onlineStore: 'Online Store',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Email Editor',
          settings: 'Settings',
          management: 'Withdrawal Management',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        de: {
          home: 'Startseite',
          orders: 'Bestellungen',
          products: 'Produkte',
          customers: 'Kunden',
          growth: 'Wachstum',
          discounts: 'Rabatte',
          content: 'Inhalte',
          markets: 'Märkte',
          finance: 'Finanzen',
          analytics: 'Analysen',
          salesChannels: 'Vertriebskanäle',
          onlineStore: 'Onlineshop',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-Mail-Editor',
          settings: 'Einstellungen',
          management: 'Widerrufsverwaltung',
          embedEnabled: 'App-Einbettung ist aktiviert',
          embedText: 'Der feste EU-Widerrufsbutton ist in Ihrem Shop aktiv.',
          manageEmbed: 'App-Einbettung verwalten',
          total: 'Gesamt',
          requested: 'Angefragt',
          approved: 'Genehmigt',
          declined: 'Abgelehnt',
          oneWithdrawal: '1 Widerruf',
          oneNewRequest: '1 neue Anfrage',
          zeroApproved: '0 genehmigte Widerrufe',
          zeroDeclined: '0 abgelehnte Widerrufe',
          showing: '1 von 1 Anfragen wird angezeigt',
          pageOne: 'Seite 1 von 1',
          status: 'Status',
          customer: 'Kunde',
          date: 'Datum',
          items: 'Artikel',
          link: 'Link',
          actions: 'Aktionen',
          details: 'Details',
          autoCollected: 'Widerrufsanfragen werden automatisch im Shop erfasst und sicher gespeichert.',
          needHelp: 'Benötigen Sie Hilfe? Kontaktieren Sie uns unter',
          templateEditor: 'E-Mail-Vorlageneditor',
          templateIntro: 'Automatische E-Mails für Widerrufsanfragen anpassen.',
          templateType: 'Vorlagentyp',
          confirmation: 'Bestätigung',
          approval: 'Genehmigung',
          rejection: 'Ablehnung',
          emailLanguage: 'E-Mail-Sprache',
          fromName: 'Absendername',
          senderHelp: 'Dieser Absendername wird für Kunden- und Händler-E-Mails verwendet.',
          subject: 'Betreff',
          variables: 'Verfügbare Variablen',
          emailBody: 'E-Mail-Editor',
          save: 'Speichern',
          preview: 'Vorschau',
          discard: 'Verwerfen',
          reset: 'Standard zurücksetzen',
        },
        nl: {
          home: 'Start',
          orders: 'Bestellingen',
          products: 'Producten',
          customers: 'Klanten',
          growth: 'Groei',
          discounts: 'Kortingen',
          content: 'Inhoud',
          markets: 'Markten',
          finance: 'Financiën',
          analytics: 'Analyse',
          salesChannels: 'Verkoopkanalen',
          onlineStore: 'Webshop',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-maileditor',
          settings: 'Instellingen',
          management: 'Herroepingsbeheer',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        fr: {
          home: 'Accueil',
          orders: 'Commandes',
          products: 'Produits',
          customers: 'Clients',
          growth: 'Croissance',
          discounts: 'Réductions',
          content: 'Contenu',
          markets: 'Marchés',
          finance: 'Finances',
          analytics: 'Analyses',
          salesChannels: 'Canaux de vente',
          onlineStore: 'Boutique en ligne',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Éditeur d’e-mails',
          settings: 'Paramètres',
          management: 'Gestion des rétractations',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        el: {
          home: 'Αρχική',
          orders: 'Παραγγελίες',
          products: 'Προϊόντα',
          customers: 'Πελάτες',
          growth: 'Ανάπτυξη',
          discounts: 'Εκπτώσεις',
          content: 'Περιεχόμενο',
          markets: 'Αγορές',
          finance: 'Οικονομικά',
          analytics: 'Αναλύσεις',
          salesChannels: 'Κανάλια πωλήσεων',
          onlineStore: 'Ηλεκτρονικό κατάστημα',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Επεξεργαστής email',
          settings: 'Ρυθμίσεις',
          management: 'Διαχείριση υπαναχωρήσεων',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        fi: {
          home: 'Etusivu',
          orders: 'Tilaukset',
          products: 'Tuotteet',
          customers: 'Asiakkaat',
          growth: 'Kasvu',
          discounts: 'Alennukset',
          content: 'Sisältö',
          markets: 'Markkinat',
          finance: 'Talous',
          analytics: 'Analytiikka',
          salesChannels: 'Myyntikanavat',
          onlineStore: 'Verkkokauppa',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Sähköpostieditori',
          settings: 'Asetukset',
          management: 'Peruuttamisten hallinta',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        sv: {
          home: 'Hem',
          orders: 'Ordrar',
          products: 'Produkter',
          customers: 'Kunder',
          growth: 'Tillväxt',
          discounts: 'Rabatter',
          content: 'Innehåll',
          markets: 'Marknader',
          finance: 'Ekonomi',
          analytics: 'Analys',
          salesChannels: 'Försäljningskanaler',
          onlineStore: 'Webbutik',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-postredigerare',
          settings: 'Inställningar',
          management: 'Hantering av ångerrätt',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        hu: {
          home: 'Kezdőlap',
          orders: 'Rendelések',
          products: 'Termékek',
          customers: 'Vásárlók',
          growth: 'Növekedés',
          discounts: 'Kedvezmények',
          content: 'Tartalom',
          markets: 'Piacok',
          finance: 'Pénzügyek',
          analytics: 'Elemzés',
          salesChannels: 'Értékesítési csatornák',
          onlineStore: 'Webáruház',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-mail-szerkesztő',
          settings: 'Beállítások',
          management: 'Elállások kezelése',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        ga: {
          home: 'Baile',
          orders: 'Orduithe',
          products: 'Táirgí',
          customers: 'Custaiméirí',
          growth: 'Fás',
          discounts: 'Lascainí',
          content: 'Ábhar',
          markets: 'Margaí',
          finance: 'Airgeadas',
          analytics: 'Anailísíocht',
          salesChannels: 'Cainéil díolacháin',
          onlineStore: 'Siopa Ar Líne',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Eagarthóir Ríomhphoist',
          settings: 'Socruithe',
          management: 'Bainistíocht Tarraingthe Siar',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        it: {
          home: 'Home',
          orders: 'Ordini',
          products: 'Prodotti',
          customers: 'Clienti',
          growth: 'Crescita',
          discounts: 'Sconti',
          content: 'Contenuti',
          markets: 'Mercati',
          finance: 'Finanze',
          analytics: 'Analisi',
          salesChannels: 'Canali di vendita',
          onlineStore: 'Negozio online',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editor e-mail',
          settings: 'Impostazioni',
          management: 'Gestione recessi',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        pl: {
          home: 'Strona główna',
          orders: 'Zamówienia',
          products: 'Produkty',
          customers: 'Klienci',
          growth: 'Wzrost',
          discounts: 'Rabaty',
          content: 'Treść',
          markets: 'Rynki',
          finance: 'Finanse',
          analytics: 'Analityka',
          salesChannels: 'Kanały sprzedaży',
          onlineStore: 'Sklep internetowy',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Edytor e-mail',
          settings: 'Ustawienia',
          management: 'Zarządzanie odstąpieniami',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        ro: {
          home: 'Acasă',
          orders: 'Comenzi',
          products: 'Produse',
          customers: 'Clienți',
          growth: 'Creștere',
          discounts: 'Reduceri',
          content: 'Conținut',
          markets: 'Piețe',
          finance: 'Finanțe',
          analytics: 'Analize',
          salesChannels: 'Canale de vânzare',
          onlineStore: 'Magazin online',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editor e-mail',
          settings: 'Setări',
          management: 'Gestionarea retragerilor',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        pt: {
          home: 'Início',
          orders: 'Encomendas',
          products: 'Produtos',
          customers: 'Clientes',
          growth: 'Crescimento',
          discounts: 'Descontos',
          content: 'Conteúdo',
          markets: 'Mercados',
          finance: 'Finanças',
          analytics: 'Análises',
          salesChannels: 'Canais de venda',
          onlineStore: 'Loja online',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editor de e-mail',
          settings: 'Definições',
          management: 'Gestão de livre resolução',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        es: {
          home: 'Inicio',
          orders: 'Pedidos',
          products: 'Productos',
          customers: 'Clientes',
          growth: 'Crecimiento',
          discounts: 'Descuentos',
          content: 'Contenido',
          markets: 'Mercados',
          finance: 'Finanzas',
          analytics: 'Análisis',
          salesChannels: 'Canales de venta',
          onlineStore: 'Tienda online',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editor de correo',
          settings: 'Configuración',
          management: 'Gestión de desistimientos',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        cs: {
          home: 'Domů',
          orders: 'Objednávky',
          products: 'Produkty',
          customers: 'Zákazníci',
          growth: 'Růst',
          discounts: 'Slevy',
          content: 'Obsah',
          markets: 'Trhy',
          finance: 'Finance',
          analytics: 'Analýzy',
          salesChannels: 'Prodejní kanály',
          onlineStore: 'Internetový obchod',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editor e-mailů',
          settings: 'Nastavení',
          management: 'Správa odstoupení',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        da: {
          home: 'Hjem',
          orders: 'Ordrer',
          products: 'Produkter',
          customers: 'Kunder',
          growth: 'Vækst',
          discounts: 'Rabatter',
          content: 'Indhold',
          markets: 'Markeder',
          finance: 'Økonomi',
          analytics: 'Analyse',
          salesChannels: 'Salgskanaler',
          onlineStore: 'Webshop',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-mail-editor',
          settings: 'Indstillinger',
          management: 'Håndtering af fortrydelse',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        et: {
          home: 'Avaleht',
          orders: 'Tellimused',
          products: 'Tooted',
          customers: 'Kliendid',
          growth: 'Kasv',
          discounts: 'Allahindlused',
          content: 'Sisu',
          markets: 'Turud',
          finance: 'Rahandus',
          analytics: 'Analüütika',
          salesChannels: 'Müügikanalid',
          onlineStore: 'Veebipood',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-posti redaktor',
          settings: 'Seaded',
          management: 'Taganemiste haldus',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        lv: {
          home: 'Sākums',
          orders: 'Pasūtījumi',
          products: 'Produkti',
          customers: 'Klienti',
          growth: 'Izaugsme',
          discounts: 'Atlaides',
          content: 'Saturs',
          markets: 'Tirgi',
          finance: 'Finanses',
          analytics: 'Analītika',
          salesChannels: 'Pārdošanas kanāli',
          onlineStore: 'Tiešsaistes veikals',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'E-pasta redaktors',
          settings: 'Iestatījumi',
          management: 'Atteikumu pārvaldība',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        lt: {
          home: 'Pradžia',
          orders: 'Užsakymai',
          products: 'Produktai',
          customers: 'Klientai',
          growth: 'Augimas',
          discounts: 'Nuolaidos',
          content: 'Turinys',
          markets: 'Rinkos',
          finance: 'Finansai',
          analytics: 'Analitika',
          salesChannels: 'Pardavimo kanalai',
          onlineStore: 'Internetinė parduotuvė',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'El. pašto redaktorius',
          settings: 'Nustatymai',
          management: 'Atsisakymų valdymas',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        mt: {
          home: 'Bidu',
          orders: 'Ordnijiet',
          products: 'Prodotti',
          customers: 'Klijenti',
          growth: 'Tkabbir',
          discounts: 'Skontijiet',
          content: 'Kontenut',
          markets: 'Swieq',
          finance: 'Finanzi',
          analytics: 'Analitika',
          salesChannels: 'Kanali tal-bejgħ',
          onlineStore: 'Ħanut Online',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editur tal-email',
          settings: 'Settings',
          management: 'Ġestjoni tal-irtirar',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        sk: {
          home: 'Domov',
          orders: 'Objednávky',
          products: 'Produkty',
          customers: 'Zákazníci',
          growth: 'Rast',
          discounts: 'Zľavy',
          content: 'Obsah',
          markets: 'Trhy',
          finance: 'Financie',
          analytics: 'Analytika',
          salesChannels: 'Predajné kanály',
          onlineStore: 'Internetový obchod',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Editor e-mailov',
          settings: 'Nastavenia',
          management: 'Správa odstúpení',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        sl: {
          home: 'Domov',
          orders: 'Naročila',
          products: 'Izdelki',
          customers: 'Stranke',
          growth: 'Rast',
          discounts: 'Popusti',
          content: 'Vsebina',
          markets: 'Trgi',
          finance: 'Finance',
          analytics: 'Analitika',
          salesChannels: 'Prodajni kanali',
          onlineStore: 'Spletna trgovina',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Urejevalnik e-pošte',
          settings: 'Nastavitve',
          management: 'Upravljanje odstopov',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
        hr: {
          home: 'Početna',
          orders: 'Narudžbe',
          products: 'Proizvodi',
          customers: 'Kupci',
          growth: 'Rast',
          discounts: 'Popusti',
          content: 'Sadržaj',
          markets: 'Tržišta',
          finance: 'Financije',
          analytics: 'Analitika',
          salesChannels: 'Prodajni kanali',
          onlineStore: 'Internetska trgovina',
          agentic: 'Agentic',
          apps: 'Apps',
          emailEditor: 'Uređivač e-pošte',
          settings: 'Postavke',
          management: 'Upravljanje odustajanjima',
          embedEnabled: 'App embed is enabled',
          embedText: 'The EU Withdrawal fixed button is active on your storefront.',
          manageEmbed: 'Manage app embed',
          total: 'Total',
          requested: 'Requested',
          approved: 'Approved',
          declined: 'Declined',
          oneWithdrawal: '1 withdrawal',
          oneNewRequest: '1 new request',
          zeroApproved: '0 approved withdrawals',
          zeroDeclined: '0 declined withdrawals',
          showing: 'Showing 1 of 1 requests',
          pageOne: 'Page 1 of 1',
          status: 'Status',
          customer: 'Customer',
          date: 'Date',
          items: 'Items',
          link: 'Link',
          actions: 'Actions',
          details: 'Details',
          autoCollected: 'Withdrawal requests are automatically collected from the storefront and securely stored.',
          needHelp: 'Need more help? Reach out to us at',
          templateEditor: 'Email Template Editor',
          templateIntro: 'Customize the automatic emails for withdrawal requests.',
          templateType: 'Template Type',
          confirmation: 'Confirmation',
          approval: 'Approval',
          rejection: 'Rejection',
          emailLanguage: 'Email Language',
          fromName: 'Mail From Name',
          senderHelp: 'This sender name is used for customer and store-owner emails.',
          subject: 'Subject',
          variables: 'Available Variables',
          emailBody: 'Email Editor',
          save: 'Save',
          preview: 'Preview',
          discard: 'Discard',
          reset: 'Reset default',
        },
      };
      function bt(key) {
        const pack = BACKEND_I18N[state.language] || BACKEND_I18N.en;
        return pack[key] || BACKEND_I18N.en[key] || key;
      }
      function exactShopifyShell(content, active = 'management') {
        return `<div class="h-[720px] overflow-hidden bg-[#f1f1f1] text-[#303030]">
    <div class="flex h-full flex-col">
      <header class="flex h-[50px] shrink-0 items-center bg-[#0f0f0f] px-4 text-white">
        <div class="flex w-[210px] items-center gap-2"><span class="text-lg">🛍️</span><strong class="italic">shopify</strong></div>
        <div class="mx-auto w-full max-w-[575px] rounded-xl border border-white/10 bg-[#292929] px-4 py-2 text-[13px] text-white/75">⌕&nbsp;&nbsp;Search <span class="float-right text-white/40">⌘ K</span></div>
        <div class="ml-auto flex w-[210px] items-center justify-end gap-4 text-xs"><span class="grid h-7 w-7 place-items-center rounded-lg bg-emerald-400 text-[#153]">EW</span><strong>Eu Withdrawal</strong></div>
      </header>
      <div class="flex min-h-0 flex-1">
        ${exactSidebar(active)}
        <main class="min-w-0 flex-1 overflow-y-auto">${content}</main>
      </div>
    </div>
  </div>`;
      }
      function shopifyIcon(name) {
        const paths = {
          home: 'M3 9.5 10 3l7 6.5V17h-5v-5H8v5H3V9.5Z',
          orders: 'M4 6h12l1 3v7H3V9l1-3Zm2-3h8v3H6V3Z',
          products: 'M3 8l5-5h7l2 2v7l-5 5H5l-2-2V8Zm10-2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z',
          customers: 'M10 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-6 7c.4-3.5 2.5-5.5 6-5.5s5.6 2 6 5.5H4Z',
          growth: 'M3 15a7 7 0 0 1 14 0h-2a5 5 0 0 0-10 0H3Zm6-5 5-5 1.5 1.5-5 5L9 10Z',
          discounts: 'M3 7l4-4h6l4 4v6l-4 4H7l-4-4V7Zm4 7 6-8 1 .8-6 8L7 14Z',
          content: 'M4 3h12v14H4V3Zm3 3h6v2H7V6Zm0 4h6v2H7v-2Z',
          markets:
            'M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 2c1 1.4 1.6 3 1.8 5H8.2C8.4 7 9 5.4 10 4Zm-2 7h4c-.2 2-.8 3.6-2 5-1.2-1.4-1.8-3-2-5Z',
          finance: 'M2 7h16v2H2V7Zm2 3h2v6H4v-6Zm5 0h2v6H9v-6Zm5 0h2v6h-2v-6ZM10 2l8 4H2l8-4Z',
          analytics: 'M3 11h3v6H3v-6Zm5-8h3v14H8V3Zm5 5h3v9h-3V8Z',
          store: 'M3 7h14l-1-4H4L3 7Zm1 2h12v8H4V9Zm3 2v4h6v-4H7Z',
          agent: 'M5 4h10v3h2v9H3V7h2V4Zm3 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
          app: 'M3 3h6v6H3V3Zm8 0h6v6h-6V3ZM3 11h6v6H3v-6Zm8 0h6v6h-6v-6Z',
        };
        return `<span class="inline-flex h-4 w-4 shrink-0"><svg viewBox="0 0 20 20" class="h-4 w-4 fill-[#555]"><path d="${
          paths[name] || paths.app
        }"/></svg></span>`;
      }
      function exactSidebar(active) {
        const rows = [
          ['home', 'home'],
          ['orders', 'orders'],
          ['products', 'products'],
          ['customers', 'customers'],
          ['growth', 'growth'],
          ['discounts', 'discounts'],
          ['content', 'content'],
          ['markets', 'markets'],
          ['finance', 'finance'],
          ['analytics', 'analytics'],
        ];
        return `<aside class="hidden w-[214px] shrink-0 bg-[#e8e8e8] px-2 py-3 text-[13px] lg:flex lg:flex-col">
  <div class="space-y-0.5">${rows
    .map(
      ([icon, key]) =>
        `<div class="flex items-center gap-3 rounded-lg px-2 py-1.5">${shopifyIcon(icon)}<span>${bt(key)}</span>${
          key === 'orders' ? '<span class="ml-auto rounded-full bg-[#ddd] px-2 py-0.5">12</span>' : ''
        }</div>`
    )
    .join('')}</div>
  <div class="mt-3 px-2 text-xs">${bt('salesChannels')} ›</div>
  <div class="mt-1 flex items-center gap-3 rounded-lg px-2 py-1.5">${shopifyIcon('store')}<span>${bt(
          'onlineStore'
        )}</span></div>
  <div class="flex items-center gap-3 rounded-lg px-2 py-1.5">${shopifyIcon('agent')}<span>${bt('agentic')}</span></div>
  <div class="mt-3 px-2 text-xs">${bt('apps')} ›</div>
  <button onclick="adminGo('management')" class="mt-1 flex w-full items-center gap-3 truncate rounded-lg px-2 py-1.5 text-left ${
    active === 'management' || active === 'detail' ? 'bg-white font-semibold' : ''
  }">${shopifyIcon('app')}<span class="truncate">Slash: EU Withdrawal Bu...</span></button>
  <div class="ml-5 border-l border-[#c9c9c9] pl-2">
   <button onclick="adminGo('email')" class="flex w-full items-center rounded-lg px-2 py-1.5 text-left ${
     active === 'email' ? 'bg-white font-semibold' : ''
   }"><span class="click-dot"></span>${bt('emailEditor')}</button>
   <button onclick="adminGo('settings')" class="flex w-full items-center rounded-lg px-2 py-1.5 text-left ${
     active === 'settings' ? 'bg-white font-semibold' : ''
   }"><span class="click-dot"></span>${bt('settings')}</button>
  </div>
  <div class="mt-auto flex items-center gap-3 rounded-lg px-2 py-2">${shopifyIcon('app')}<span>${bt(
          'settings'
        )}</span></div>
 </aside>`;
      }
      function appPageHeader(title) {
        return `<div class="flex h-[52px] items-center border-b border-[#ddd] px-5"><span class="mr-2 grid h-5 w-5 place-items-center rounded bg-blue-700 text-[10px] text-white">✥</span><span class="text-sm text-[#777]">›</span><h2 class="ml-2 text-[18px] font-semibold">${title}</h2><span class="ml-auto">•••</span></div>`;
      }
      function requestsView() {
        if (state.adminPage === 'detail') return withdrawalDetailView();
        if (state.adminPage === 'email') return emailEditorView();
        if (state.adminPage === 'settings') return exactSettingsView();
        return managementView();
      }
      function managementView() {
        return exactShopifyShell(
          `${appPageHeader(bt('management'))}
  <div class="p-5">
   <div class="flex items-center rounded-xl border border-emerald-300 bg-emerald-50 px-4 py-3">
    <span class="mr-3 text-emerald-600">●</span><div><strong class="text-sm">${bt(
      'embedEnabled'
    )}</strong><p class="mt-1 text-[13px]">${bt('embedText')}</p></div>
    <span class="ml-auto rounded-lg border border-[#bbb] bg-white px-4 py-2 text-sm font-semibold text-[#777]">${bt(
      'manageEmbed'
    )}</span>
   </div>
   <div class="mt-4 grid grid-cols-4 gap-3 rounded-xl border border-[#d7d7d7] bg-white p-4 shadow-sm">
    ${summaryCard('T', bt('total'), bt('oneWithdrawal'), 'blue')}${summaryCard(
            'R',
            bt('requested'),
            bt('oneNewRequest'),
            'amber'
          )}${summaryCard('A', bt('approved'), bt('zeroApproved'), 'green')}${summaryCard(
            'D',
            bt('declined'),
            bt('zeroDeclined'),
            'red'
          )}
   </div>
   <div class="mt-4 overflow-hidden rounded-xl border border-[#d7d7d7] bg-white shadow-sm">
    <div class="flex items-center border-b border-[#ddd] px-5 py-4 text-sm"><input type="checkbox" disabled class="mr-2"> ${bt(
      'showing'
    )} <span class="ml-auto">${bt('pageOne')}</span></div>
    <table class="w-full text-left text-sm"><thead><tr class="border-b border-[#ddd] text-[#4d5968]"><th class="w-16 px-5 py-4"></th><th>${bt(
      'status'
    )}</th><th>${bt('customer')}</th><th>${bt('date')}</th><th>${bt('items')}</th><th>${bt('link')}</th><th>${bt(
            'actions'
          )}</th></tr></thead>
    <tbody><tr><td class="px-5 py-4"><input type="checkbox" disabled></td><td><span class="rounded-lg bg-amber-200 px-3 py-1 font-semibold">${bt(
      'requested'
    )}</span></td><td><div class="flex items-center gap-3"><span class="grid h-8 w-8 place-items-center rounded-lg bg-sky-400">A</span><div><strong>Emma Demo</strong><div class="text-[#667]">emma.demo@example.com</div></div></div></td><td>08/05/2026, 10:24 AM</td><td>2 ${bt(
            'items'
          ).toLowerCase()}</td><td class="font-semibold text-blue-700">#DEMO-1048</td><td><button onclick="openWithdrawalDetail()" class="inline-flex items-center rounded-lg border border-[#bbb] px-4 py-2 font-semibold"><span class="click-dot"></span>${bt(
            'details'
          )}</button></td></tr></tbody></table>
   </div>
   <div class="mt-4 flex items-center rounded-xl border border-[#d7d7d7] bg-white p-4 text-sm shadow-sm"><span class="mr-3 grid h-8 w-8 place-items-center rounded-lg bg-sky-200 text-blue-700">i</span>${bt(
     'autoCollected'
   )}</div>
   <p class="mt-4 text-center text-sm">${bt('needHelp')} <u>support@slashthemes.com</u></p>
  </div>`,
          'management'
        );
      }
      function summaryCard(letter, label, desc, color) {
        const cls = {
          blue: 'bg-sky-100 text-blue-700',
          amber: 'bg-amber-200 text-amber-900',
          green: 'bg-green-200 text-green-800',
          red: 'bg-rose-200 text-rose-800',
        }[color];
        return `<div class="rounded-lg border border-[#ccd2d8] p-5"><div class="flex items-center gap-4"><span class="grid h-10 w-10 place-items-center rounded-lg bg-[#f6f6f6] text-blue-600">${letter}</span><div><span class="rounded-lg px-3 py-1 text-sm font-semibold ${cls}">${label}</span><p class="mt-3 text-sm">${desc}</p></div></div></div>`;
      }
      function withdrawalDetailView() {
        return exactShopifyShell(
          `${appPageHeader(state.language === 'de' ? 'Widerruf #DEMO-1048' : 'Withdrawal #DEMO-1048')}
 <div class="mx-auto max-w-[1010px] p-6">
  <div class="mb-4 flex items-center"><button onclick="adminGo('management')" class="text-sm font-semibold text-blue-700 underline">Withdrawals</button><strong class="ml-1 text-sm">/ Withdrawal #DEMO-1048</strong><button class="ml-auto rounded-lg border border-[#bbb] bg-white px-4 py-2 text-sm font-semibold">Delete</button></div>
  <div class="grid grid-cols-[2fr_1fr] gap-4">
   <div class="space-y-4">
    <section class="rounded-xl border border-[#d7d7d7] bg-white p-5 shadow-sm"><h3 class="text-lg font-semibold">Customer Data</h3><hr class="my-4"><div class="flex items-center rounded-lg border border-[#ddd] p-4"><span class="grid h-10 w-10 place-items-center rounded-lg bg-teal-400">A</span><div class="ml-4"><strong>Emma Demo</strong><div>emma.demo@example.com</div></div><span class="ml-auto rounded-lg bg-amber-200 px-3 py-1 font-semibold">Requested</span></div><div class="mt-4 flex justify-between"><span>Submitted on</span><strong>August 5, 2026</strong></div><div class="mt-4 flex justify-between"><span>Order Reference</span><strong>#DEMO-1048</strong></div></section>
    <section class="rounded-xl border border-[#d7d7d7] bg-white p-5 shadow-sm"><h3 class="text-lg font-semibold">Affected items</h3><hr class="my-4"><p class="mb-4">Selected items from order:</p>${affectedItem(
      '👕',
      'Classic Linen Shirt'
    )}${affectedItem('👜', 'Everyday Canvas Tote')}</section>
   </div>
   <div class="space-y-4">
    <section class="rounded-xl border border-[#d7d7d7] bg-white p-5 shadow-sm"><h3 class="text-lg font-semibold">Order Assignment</h3><hr class="my-4"><div class="flex items-center rounded-lg border border-[#ddd] p-4 shadow-sm"><span class="grid h-9 w-9 place-items-center rounded-lg bg-emerald-700 font-bold text-white">OK</span><strong class="ml-3">Order linked</strong></div><strong class="mt-4 block">Shopify Order</strong><a class="mt-3 block text-blue-700 underline">#DEMO-1048</a></section>
    <section class="rounded-xl border border-[#d7d7d7] bg-white p-5 shadow-sm"><h3 class="text-lg font-semibold">Internal Status</h3><hr class="my-4"><strong>Additional Notes</strong><div class="mt-3 min-h-20 rounded-lg bg-[#f4f4f4] p-4">No additional notes provided.</div><div class="mt-4 flex gap-2"><button class="rounded-lg bg-[#333] px-4 py-2 font-semibold text-white">Approve & Notify</button><button class="rounded-lg bg-rose-700 px-4 py-2 font-semibold text-white">Deny & Notify</button></div></section>
   </div>
  </div><p class="mt-5 text-center text-sm">${
    state.language === 'de' ? 'Benötigen Sie Hilfe? Kontaktieren Sie uns unter' : 'Need more help? Reach out to us at'
  } <u>support@slashthemes.com</u></p>
 </div>`,
          'detail'
        );
      }
      function affectedItem(icon, name) {
        return `<div class="mb-3 flex items-center rounded-lg bg-[#f4f4f4] p-3"><span class="grid h-16 w-20 place-items-center rounded-lg border bg-white text-3xl">${icon}</span><div class="ml-4"><strong>${name}</strong><div class="mt-2"><span class="rounded-lg bg-sky-200 px-3 py-1 font-semibold text-blue-800">Return: 1</span></div></div></div>`;
      }
      function emailEditorView() {
        const active = state.emailTemplate;
        const opts = BACKEND_LANGUAGES.map(
          ([code, name]) => `<option value="${code}" ${state.emailLocale === code ? 'selected' : ''}>${name}</option>`
        ).join('');
        const subjects = {
          confirmation: 'Confirmation of Receipt of Your Withdrawal Notice',
          approval: 'Your Withdrawal Request Has Been Approved',
          rejection: 'Your Withdrawal Request Has Been Rejected',
        };
        return exactShopifyShell(
          `${appPageHeader(bt('templateEditor'))}
  <div class="p-5">
   <h1 class="text-[26px] font-semibold">${bt('templateEditor')}</h1><p class="mt-2 text-sm">${bt('templateIntro')}</p>
   <div class="mt-7 text-sm font-semibold">${bt('templateType')}</div>
   <div class="mt-2 flex border-b border-[#ccc]">${[
     ['confirmation', bt('confirmation')],
     ['approval', bt('approval')],
     ['rejection', bt('rejection')],
   ]
     .map(
       ([type, label]) =>
         `<button onclick="setEmailTemplate('${type}')" class="inline-flex items-center px-5 py-3 ${
           active === type ? 'bg-[#111] text-white' : 'bg-transparent'
         }"><span class="click-dot"></span>${label}</button>`
     )
     .join('')}</div>
   <div class="mt-5 text-sm font-semibold">${bt('emailLanguage')}</div>
   <span class="select-click-wrap mt-2"><span class="click-dot"></span><select onchange="setEmailLocale(this.value)" class="w-72 rounded border border-[#bbb] bg-white px-3 py-2">${opts}</select></span>
   <label class="mt-5 block text-sm font-semibold">${bt(
     'fromName'
   )}</label><input readonly value="Demo Plus" class="mt-2 w-full rounded border border-[#bbb] bg-white px-3 py-2"><p class="mt-2 text-xs text-[#666]">${bt(
            'senderHelp'
          )}</p>
   <label class="mt-5 block text-sm font-semibold">${bt('subject')}</label><input readonly value="${
            subjects[active]
          }" class="mt-2 w-full rounded border border-[#bbb] bg-white px-3 py-2">
   <div class="mt-5 rounded border border-sky-400 bg-sky-100 p-3 text-sm text-blue-800"><strong>${bt(
     'variables'
   )}:</strong> Customer Name, Date, Item List, Order Number, Withdrawal ID, Receipt Date & Time, Rejection Reason</div>
   <label class="mt-5 block text-sm font-semibold">${bt(
     'emailBody'
   )}</label><textarea readonly class="mt-2 h-64 w-full rounded border border-[#bbb] bg-white p-3 text-sm leading-7">Dear {{ customer_name }},

We hereby confirm receipt of your withdrawal notice dated {{ date }} for order number {{ order_number }}.

Items to be withdrawn:
{{ item_list }}

Date and time of receipt: {{ receipt_date_time }}
Withdrawal ID: {{ withdrawal_id }}

Best regards,
Demo Plus</textarea>
   <div class="mt-4 flex gap-2 border-t pt-4"><span class="rounded bg-[#333] px-4 py-2 text-white">${bt(
     'save'
   )}</span><span class="rounded border bg-white px-4 py-2">${bt(
            'preview'
          )}</span><span class="rounded border bg-white px-4 py-2">${bt(
            'discard'
          )}</span><span class="rounded border bg-white px-4 py-2">${bt('reset')}</span></div>
   <p class="mt-4 text-center text-sm">${bt('needHelp')} <u>support@slashthemes.com</u></p>
  </div>`,
          'email'
        );
      }
      function exactSettingsView() {
        return exactShopifyShell(
          `${appPageHeader(state.language === 'de' ? 'Einstellungen' : 'Settings')}
 <div class="mx-auto max-w-[610px] space-y-4 p-5">
  <section class="rounded-xl border border-[#d7d7d7] bg-white p-5"><strong>Return Rules & Automation</strong><p class="mt-2 text-sm text-[#666]">Configure validation rules and automatic actions for withdrawals.</p>
   ${checkRow(
     'Limit order age for withdrawals',
     'Only allow withdrawals for orders within the specified number of days.'
   )}
   <div class="ml-5 mt-3 text-sm"><strong>Maximum days:</strong> <input value="14" class="ml-2 w-20 rounded border px-2 py-1"> days</div>
   ${checkRow('Extend deadline to next working day', 'If the deadline falls on a weekend, extend it to Monday.')}
   ${checkRow(
     'Exclude products tagged as slash-withdrawal',
     'Products carrying the tag slash-eu-withdrawal are hidden from the form.'
   )}
   ${checkRow(
     'Automatically create Shopify Return Request',
     'Creates a return request when the order has returnable fulfillment items.'
   )}
   ${checkRow('Tag orders with withdrawal status', 'Adds eu-withdrawal-open to the linked Shopify order.')}
   ${checkRow('EU Customer Only', 'Restrict the form to delivery addresses in the EU, EEA/EFTA, and Northern Ireland.')}
  </section>
  <section class="flex items-center rounded-xl border border-[#d7d7d7] bg-white p-5"><div><strong>Custom CSS</strong><p class="mt-2 text-sm text-[#666]">Manage secure custom CSS overrides for the extension forms.</p></div><button class="ml-auto rounded border px-4 py-2">Manage</button></section>
  <section class="rounded-xl border border-[#d7d7d7] bg-white p-5"><strong>Legal</strong><p class="mt-2 text-sm text-[#666]">GDPR-compliant settings for data protection and retention.</p>${checkRow(
    'Enable automatic deletion of withdrawals',
    ''
  )}<div class="ml-5 mt-3 text-sm">Automatically delete requests after <select class="ml-2 rounded border px-3 py-2"><option>6 months</option></select></div><div class="mt-4 rounded bg-sky-100 p-3 text-sm text-blue-800"><strong>Legal Notice:</strong> Business-relevant documents may need to be retained separately under applicable law.</div><strong class="mt-4 block">Data Processing Agreement (DPA)</strong><p class="text-sm text-[#666]">Manage your data processing agreement for GDPR compliance.</p><button class="float-right -mt-9 rounded border px-3 py-2">Manage DPA</button><label class="mt-4 block text-sm font-semibold">Compliance note</label><textarea class="mt-2 h-16 w-full rounded border p-2">EU Directive 2023/2673 requires online retailers to provide electronic cancellation from June 19, 2026.</textarea><label class="mt-3 block text-sm font-semibold">Privacy Policy Link</label><input value="https://myshop.com/pages/privacy-policy" class="mt-2 w-full rounded border p-2"><label class="mt-3 block text-sm font-semibold">Return and Refund Policy Link</label><input value="https://myshop.com/pages/refund-policy" class="mt-2 w-full rounded border p-2"><button class="mt-4 float-right rounded bg-[#333] px-4 py-2 text-white">Save</button><div class="clear-both"></div></section>
  <section class="rounded-xl border border-[#d7d7d7] bg-white p-5"><strong>Delete All Data</strong><div class="mt-1 text-sm font-semibold text-red-600">Warning: Danger Zone</div><p class="mt-2 text-sm">Irreversible actions that cannot be undone.</p><ul class="ml-5 mt-4 list-disc text-sm"><li>All withdrawal requests</li><li>All email templates</li><li>All form customization data</li></ul><p class="mt-5 font-semibold text-red-600">This action CANNOT be undone!</p><button class="mt-3 rounded bg-red-600 px-4 py-2 text-white">Delete All Data</button></section>
  <p class="text-center text-sm">${
    state.language === 'de' ? 'Benötigen Sie Hilfe? Kontaktieren Sie uns unter' : 'Need more help? Reach out to us at'
  } <u>support@slashthemes.com</u></p>
 </div>`,
          'settings'
        );
      }
      function checkRow(title, desc) {
        return `<label class="mt-4 flex items-start gap-3 text-sm"><input type="checkbox" class="mt-1"><span><strong>${title}</strong>${
          desc ? `<span class="mt-1 block text-[#666]">${desc}</span>` : ''
        }</span></label>`;
      }
      function settingsView() {
        state.adminPage = 'settings';
        return exactSettingsView();
      }

      function settingsView() {
        state.adminPage = 'settings';
        return exactSettingsView();
      }

      document.addEventListener('DOMContentLoaded', init);
